export const ASTEROID_DATA = [
  {
    position: { x: -590, y: -3285 },
    pointVectors: [
      { x: -3.364421469376353, y: 74.92449978596052 },
      { x: -68.44125197990343, y: 18.88901869932276 },
      { x: -42.97034753919729, y: -65.09646098184295 },
      { x: 48.008360558664705, y: -60.201306601013634 },
      { x: 53.36550545939969, y: 20.02805100509736 },
    ],
  },
  {
    position: { x: 3458, y: 4780 },
    pointVectors: [
      { x: 5.437628079823489, y: 5.867895778344662 },
      { x: -0.34227585826858153, y: 8.993489158099125 },
      { x: -8.06835669522391, y: 7.476738609757299 },
      { x: -12.990595450587625, y: -0.4943984619435059 },
      { x: -6.797035099779363, y: -7.334869722930827 },
      { x: 0.4563678110247686, y: -11.9913188774655 },
      { x: 6.601382750637741, y: -6.117331589801429 },
      { x: 13.98987202370975, y: 0.5324291128622292 },
    ],
  },
  {
    position: { x: 3414, y: -1884 },
    pointVectors: [
      { x: 80.83485819519866, y: 5.169690567347703 },
      { x: 19.567302277692363, y: 76.53836084979488 },
      { x: -58.296857908176484, y: 36.9117374019956 },
      { x: -55.429427683024215, y: -45.95191559372023 },
      { x: 23.25245441673075, y: -58.55188608061963 },
    ],
  },
  {
    position: { x: 3582, y: 40 },
    pointVectors: [
      { x: 54.04359709844543, y: 21.054444012153358 },
      { x: 37.47531719446149, y: 68.407606310808 },
      { x: -18.00346024826499, y: 90.22125813293196 },
      { x: -53.8384181537073, y: 43.155819198649915 },
      { x: -85.97837152313929, y: -1.9286342911586032 },
      { x: -58.61205834423519, y: -51.46480949786922 },
      { x: -12.27305739557585, y: -80.06479914522299 },
      { x: 37.38929195078188, y: -61.530812179096074 },
      { x: 54.93333298327619, y: -18.609914759302388 },
    ],
  },
  {
    position: { x: -4856, y: -2782 },
    pointVectors: [
      { x: 82.99790612052874, y: -0.589558824797184 },
      { x: 42.51566484678773, y: 72.44596774586988 },
      { x: -40.98838014096473, y: 72.17307457369242 },
      { x: -65.9983349874084, y: 0.46880581248927655 },
      { x: -25.306943361183098, y: -43.122599848732115 },
      { x: 48.39591872065729, y: -85.21640130387773 },
    ],
  },
  {
    position: { x: -3869, y: 1646 },
    pointVectors: [
      { x: -47.248087380115834, y: -36.98132283898102 },
      { x: 10.223310980764857, y: -72.28059153459228 },
      { x: 64.92594352319732, y: -26.16527962056955 },
      { x: 42.52327864210427, y: 33.283190555082896 },
      { x: -12.464036675178983, y: 88.12291296683169 },
      { x: -51.94075481855785, y: 20.932223696455647 },
    ],
  },
  {
    position: { x: 4695, y: -2550 },
    pointVectors: [
      { x: -11.912551422584858, y: 1.4460700551050314 },
      { x: -4.213729320725928, y: -9.068874528388548 },
      { x: 8.055188070475426, y: -7.490924185257143 },
      { x: 10.487435199409111, y: 5.832126793734408 },
      { x: -2.498043694268674, y: 12.757734034754154 },
    ],
  },
  {
    position: { x: 2223, y: -3209 },
    pointVectors: [
      { x: -3.0835079419971763, y: -10.558976217969256 },
      { x: 10.741931650435781, y: -7.321946764171807 },
      { x: 11.865028401266072, y: 9.177205513507339 },
      { x: -3.0369274141610014, y: 8.47213502495784 },
      { x: -14.99323567346245, y: -0.4504265090033647 },
    ],
  },
  {
    position: { x: 2872, y: -2689 },
    pointVectors: [
      { x: -91.94309862781819, y: 23.905367905876215 },
      { x: -64.01309774697366, y: -47.98253137170231 },
      { x: -2.5470887454499427, y: -84.96182871691735 },
      { x: 48.8190107420048, y: -41.384830435462945 },
      { x: 59.850644353071836, y: 11.785600134151446 },
      { x: 36.85496808413804, y: 71.0050091720096 },
      { x: -33.34863620620212, y: 74.91240526899657 },
    ],
  },
  {
    position: { x: -1926, y: 1735 },
    pointVectors: [
      { x: -44.470194842388196, y: 64.08121230657258 },
      { x: -97.42289966839529, y: 17.600528975055987 },
      { x: -55.86567226726841, y: -38.76888781131279 },
      { x: -10.844770378569827, y: -60.028251310829425 },
      { x: 50.17150187346364, y: -72.29675234587674 },
      { x: 84.6299936513333, y: -15.289348402573859 },
      { x: 46.00702422010339, y: 31.927319374022307 },
      { x: 12.800384709131608, y: 70.85301794065113 },
    ],
  },
  {
    position: { x: 863, y: -4140 },
    pointVectors: [
      { x: -5.0789103171533885, y: 6.18099263794359 },
      { x: -14.276902799442894, y: 4.601091876420169 },
      { x: -11.59842639293986, y: -3.078393283444481 },
      { x: -5.395274744754549, y: -5.906861300946022 },
      { x: -2.1861183780788966, y: -12.814869739370186 },
      { x: 5.872109818539289, y: -13.802837616918286 },
      { x: 7.441386325461849, y: -5.062190193506107 },
      { x: 14.994865299648788, y: -0.39244699691629514 },
      { x: 10.261325018302443, y: 6.221351048507096 },
      { x: 5.268859606632804, y: 10.781424694612175 },
      { x: -1.1636929184664455, y: 9.932060148403806 },
    ],
  },
  {
    position: { x: 3921, y: -3254 },
    pointVectors: [
      { x: -5.684410337783287, y: 6.97764137167442 },
      { x: -13.750570353668504, y: 2.6309342349843785 },
      { x: -12.224679937292409, y: -6.823283698539907 },
      { x: -5.334349195792832, y: -14.0194407398207 },
      { x: 4.596829293651606, y: -13.223810360294285 },
      { x: 6.8694154221771475, y: -4.1001380168909884 },
      { x: 12.833917568707427, y: 2.071366659870447 },
      { x: 9.153741060016896, y: 10.592876125309912 },
      { x: 0.14514496320171263, y: 9.998946591499385 },
    ],
  },
  {
    position: { x: -4789, y: 597 },
    pointVectors: [
      { x: 7.734307343097082, y: -2.044624640982926 },
      { x: 7.23908254723744, y: 3.4052435851613163 },
      { x: 3.776186895845122, y: 8.16948055433438 },
      { x: -3.1446851868805363, y: 11.580628440435094 },
      { x: -6.568568724442415, y: 4.566607593419533 },
      { x: -12.946658318676498, y: -1.1764516052284641 },
      { x: -7.752044508784682, y: -7.804217189047295 },
      { x: -1.0057707341925697, y: -11.957776767871264 },
      { x: 6.915845663805282, y: -9.806685411209319 },
    ],
  },
  {
    position: { x: -4514, y: -3631 },
    pointVectors: [
      { x: -1.5167267536683435, y: 9.884307763050819 },
      { x: -8.673526654674792, y: 4.9769403623758555 },
      { x: -9.29898407701092, y: -3.6781646422499077 },
      { x: -2.6299051421861885, y: -8.60718298533862 },
      { x: 6.7861967963892855, y: -9.896844600208482 },
      { x: 12.966188279949495, y: -0.9369959919339863 },
      { x: 8.816859126969094, y: 9.553166759519158 },
    ],
  },
  {
    position: { x: 3169, y: -2898 },
    pointVectors: [
      { x: 26.530176015269145, y: 77.58962405243912 },
      { x: -16.756901746357865, y: 67.96474265281161 },
      { x: -40.673053455523146, y: 38.49289184517262 },
      { x: -70.7492294021499, y: 13.36213078075385 },
      { x: -79.71979324943328, y: -32.26072789426196 },
      { x: -47.315040644065554, y: -66.9722847814708 },
      { x: -2.894336881040795, y: -65.93650592819615 },
      { x: 44.787355835663526, y: -76.90964021011708 },
      { x: 48.97967038425057, y: -25.019829916491602 },
      { x: 66.67238467459534, y: 6.617637176725951 },
      { x: 72.10412720414703, y: 57.14013335763387 },
    ],
  },
  {
    position: { x: -3401, y: -3120 },
    pointVectors: [
      { x: 3.8606189015171037, y: 8.129921383214532 },
      { x: -7.265575398999512, y: 6.871056259517388 },
      { x: -7.023959281318404, y: -3.829359739484011 },
      { x: 2.207122121624327, y: -11.795279222648208 },
      { x: 14.875019263079023, y: -1.9323048214575194 },
    ],
  },
  {
    position: { x: -1078, y: 1784 },
    pointVectors: [
      { x: 10.342462806246274, y: -3.746126412898057 },
      { x: 9.84536248577636, y: 1.7518097852414085 },
      { x: 9.180514955433516, y: 7.727751623406483 },
      { x: 3.0650125196438576, y: 8.462015023292407 },
      { x: -1.7518097852414165, y: 9.845362485776358 },
      { x: -5.7958137175548625, y: 6.885386216575137 },
      { x: -7.521791131815471, y: 2.7244555730167694 },
      { x: -13.783507480086906, y: -2.452533699337958 },
      { x: -6.120343303622354, y: -5.151834415604311 },
      { x: -4.427240306152273, y: -12.222910589200133 },
      { x: 2.277352720813795, y: -12.798971231509274 },
      { x: 9.015710227307524, y: -10.710600781339135 },
    ],
  },
  {
    position: { x: 2292, y: -150 },
    pointVectors: [
      { x: 32.47835124812427, y: 50.449546085207395 },
      { x: 0.05772340223284814, y: 72.99997717813913 },
      { x: -27.538747579567925, y: 42.9257193503946 },
      { x: -80.01868417188551, y: 36.61980588970999 },
      { x: -56.42621892014343, y: -8.067330312814034 },
      { x: -49.1573652128367, y: -42.527090722641624 },
      { x: -26.27167882097998, y: -89.21210059138431 },
      { x: 27.81640297355961, y: -95.01182939830463 },
      { x: 70.23653127171009, y: -60.95760555433662 },
      { x: 66.31047617346387, y: -9.587530946415784 },
      { x: 58.23745233470608, y: 26.540518939215147 },
    ],
  },
  {
    position: { x: -4298, y: -1062 },
    pointVectors: [
      { x: -7.597958435123209, y: 7.95430874546243 },
      { x: -13.773840015514748, y: 2.506258411857142 },
      { x: -9.912895444003125, y: -4.7680712994104955 },
      { x: -7.114225753620021, y: -13.205596992432023 },
      { x: 1.2039153740225195, y: -8.919113620320811 },
      { x: 10.360852411531651, y: -10.84678465290331 },
      { x: 12.789994300120838, y: -2.3272399538673416 },
      { x: 10.814067757094318, y: 5.201532326629636 },
      { x: 4.7428171690800145, y: 8.803731328288013 },
      { x: -1.337683748913909, y: 9.910126244800901 },
    ],
  },
  {
    position: { x: -1741, y: 1125 },
    pointVectors: [
      { x: -44.38846220541005, y: -43.28584552759578 },
      { x: -0.8676947316983209, y: -68.99454402960123 },
      { x: 52.361909912414276, y: -53.695720409770196 },
      { x: 90.99280444483641, y: -1.1443510229644578 },
      { x: 50.83194865458246, y: 49.569274717085506 },
      { x: 0.9054205895982567, y: 71.99430681349693 },
      { x: -56.550862705407354, y: 57.99137804255187 },
      { x: -83.99335794907977, y: 1.0563240211979714 },
    ],
  },
  {
    position: { x: -3017, y: 612 },
    pointVectors: [
      { x: 54.096994222237925, y: -68.13600528442475 },
      { x: 81.39988283461715, y: -27.74993827940165 },
      { x: 93.18774510405655, y: 23.066082511371217 },
      { x: 52.8765850440658, y: 55.97380417729062 },
      { x: 13.297456263140724, y: 70.76141361596629 },
      { x: -29.32580781283226, y: 72.27722321813994 },
      { x: -45.766686696230224, y: 32.27089073529119 },
      { x: -97.9096083285768, y: 4.20815837923011 },
      { x: -81.18713441349219, y: -47.3777290055734 },
      { x: -32.24051803190362, y: -63.25779791483812 },
      { x: 5.382733599232782, y: -53.73105414003796 },
    ],
  },
  {
    position: { x: 2580, y: 921 },
    pointVectors: [
      { x: -13.87094983891753, y: 1.8965101018011312 },
      { x: -13.217758731931205, y: -7.091604480260896 },
      { x: -3.4800271536488587, y: -7.203430502883097 },
      { x: 2.128003660980352, y: -11.809809499685176 },
      { x: 10.82902872765463, y: -10.3794092710342 },
      { x: 7.926257050810018, y: -1.0837200581720725 },
      { x: 12.33657481646912, y: 6.618830848243507 },
      { x: 4.785037336267182, y: 9.904716941464256 },
      { x: -2.12800366098035, y: 11.809809499685176 },
      { x: -10.829028727654629, y: 10.3794092710342 },
    ],
  },
  {
    position: { x: -3412, y: 1165 },
    pointVectors: [
      { x: -11.271358182761343, y: 8.30400413751697 },
      { x: -14.969521581552279, y: 0.9557319809656746 },
      { x: -10.487896507784964, y: -5.831297183474014 },
      { x: -5.197814153621826, y: -9.694468939782551 },
      { x: 1.1843810354558977, y: -14.953168278423554 },
      { x: 5.4483947111361255, y: -7.163448546033111 },
      { x: 11.27511196897392, y: -4.107535768207141 },
      { x: 12.681423378452902, y: 2.8603323402059804 },
      { x: 5.613464494675566, y: 5.699913715751914 },
      { x: 2.666203843643822, y: 12.723653447973932 },
      { x: -5.349199613562607, y: 14.013781199029106 },
    ],
  },
  {
    position: { x: -3487, y: -1769 },
    pointVectors: [
      { x: -49.309378340035494, y: -8.281618665408272 },
      { x: -42.18491071546224, y: -38.33318807415422 },
      { x: -22.27508486051962, y: -83.06515872769191 },
      { x: 18.257735918784974, y: -57.154659294933325 },
      { x: 66.30532141095925, y: -54.76864388123362 },
      { x: 87.37555842743924, y: -10.464788076838952 },
      { x: 45.87837645815523, y: 22.274976398725716 },
      { x: 38.52727994501643, y: 63.17949588306585 },
      { x: -2.0529694929500986, y: 86.97577430676324 },
      { x: -32.49981437252065, y: 48.03917220094139 },
      { x: -72.61533030830988, y: 31.112920213555206 },
    ],
  },
  {
    position: { x: 2262, y: -1953 },
    pointVectors: [
      { x: -60.03166316739132, y: -10.825867972447853 },
      { x: -75.59057579456703, y: -63.93015603802182 },
      { x: -33.1599144319815, y: -92.21941267902146 },
      { x: 14.552806126897108, y: -80.69830130698506 },
      { x: 57.47256451902974, y: -67.9551640981461 },
      { x: 74.34013879227243, y: -26.730951429862575 },
      { x: 94.4760600667142, y: 17.03743156319669 },
      { x: 58.79267006244096, y: 49.72345469623926 },
      { x: 29.099516746432613, y: 80.92723969791685 },
      { x: -9.938501745198117, y: 55.11103503891661 },
      { x: -60.05560112662664, y: 71.00932877671441 },
      { x: -71.51709554699626, y: 25.715852008475398 },
    ],
  },
  {
    position: { x: -325, y: -4259 },
    pointVectors: [
      { x: -67.06710032345707, y: 45.42030442658156 },
      { x: -63.965083671471, y: -2.113781185864442 },
      { x: -70.23544905155916, y: -54.662434052334675 },
      { x: -23.027276875182945, y: -79.74173637257759 },
      { x: 33.34545438515573, y: -92.15248597757686 },
      { x: 59.61520028751737, y: -40.3736039347392 },
      { x: 65.96399253620447, y: 2.1798368479226684 },
      { x: 52.08471502699895, y: 40.53618705004591 },
      { x: 26.079084653821663, y: 90.30991830147342 },
      { x: -30.62337647616342, y: 84.62983406103997 },
    ],
  },
  {
    position: { x: -2257, y: -393 },
    pointVectors: [
      { x: -4.664148565215632, y: -12.134484668151217 },
      { x: 4.048660352197079, y: -6.899880386828993 },
      { x: 12.868118497765801, y: -1.8470317613559386 },
      { x: 10.195455019737242, y: 9.59440967128852 },
      { x: -0.6539710323391441, y: 7.973225312811703 },
      { x: -9.962194253612518, y: 6.689894293132719 },
      { x: -12.395171201852236, y: -3.919149254209768 },
    ],
  },
  {
    position: { x: 3637, y: -4864 },
    pointVectors: [
      { x: 89.07604030627476, y: -12.863088406557438 },
      { x: 37.108898675336874, y: 75.35867328386017 },
      { x: -63.0698901409821, y: 61.36928350245299 },
      { x: -68.12340925450988, y: -35.891518657512364 },
      { x: 11.214489878188367, y: -65.04025843100573 },
    ],
  },
  {
    position: { x: -4343, y: 777 },
    pointVectors: [
      { x: -53.619234013703625, y: -40.1743418587497 },
      { x: 8.93550405576042, y: -74.46580938437108 },
      { x: 81.82901447283005, y: -35.00017700534342 },
      { x: 44.81607619055827, y: 33.57855438940271 },
      { x: -9.650344380221172, y: 80.42307413512079 },
      { x: -90.10385863300387, y: 38.539520747456805 },
    ],
  },
  {
    position: { x: 3001, y: 3493 },
    pointVectors: [
      { x: -10.021786783276944, y: -6.600287090008705 },
      { x: -3.8758907084972796, y: -10.294535988367054 },
      { x: 2.9153149816420183, y: -10.606645961745569 },
      { x: 10.155327516106903, y: -8.115991808805749 },
      { x: 11.987347234076806, y: -0.5509140492591953 },
      { x: 9.186637884670528, y: 6.050263165841317 },
      { x: 4.228244409269761, y: 11.230402896400424 },
      { x: -3.9754295204209322, y: 14.46360812965305 },
      { x: -11.717685595507964, y: 9.364605933237401 },
      { x: -10.988401631237071, y: 0.5050045451542636 },
    ],
  },
  {
    position: { x: 253, y: -2802 },
    pointVectors: [
      { x: -75.08631726117322, y: 11.749253599886252 },
      { x: -50.89904372704984, y: -37.12529256008454 },
      { x: -12.831421694612624, y: -82.00216227207076 },
      { x: 43.607486499146916, y: -59.78617834605855 },
      { x: 92.86991871776688, y: -14.53197155775406 },
      { x: 53.32280771405222, y: 38.89316363437427 },
      { x: 13.140612578820166, y: 83.97811798947005 },
      { x: -45.375357573436645, y: 62.20994233306093 },
    ],
  },
  {
    position: { x: -2376, y: -4039 },
    pointVectors: [
      { x: -9.908655520506782, y: 1.348534677318478 },
      { x: -9.552042631186769, y: -7.263503395193709 },
      { x: -1.887948548245864, y: -13.872117728709497 },
      { x: 9.079379243992141, y: -11.940053288983458 },
      { x: 14.862983280760176, y: -2.022802015977712 },
      { x: 10.348046183785666, y: 7.868795344793187 },
      { x: 1.4833881450503232, y: 10.899521072557462 },
      { x: -7.868795344793196, y: 10.348046183785659 },
    ],
  },
  {
    position: { x: 989, y: 936 },
    pointVectors: [
      { x: 87.80470305407124, y: 5.859532539919167 },
      { x: 25.59108130231268, y: 52.04898229339765 },
      { x: -53.98585215236356, y: 80.58863299115542 },
      { x: -58.86906227488868, y: -3.928550225627582 },
      { x: -24.267404683227596, y: -49.35679355408396 },
      { x: 29.497424371909947, y: -44.032964417847836 },
    ],
  },
  {
    position: { x: -4031, y: 2997 },
    pointVectors: [
      { x: 33.91503420494394, y: 77.94081379404172 },
      { x: -20.143541190542855, y: 51.178489117058774 },
      { x: -69.68825703937847, y: 30.324030583244 },
      { x: -62.34470492441705, y: -24.53849563211584 },
      { x: -33.91503420494395, y: -77.9408137940417 },
      { x: 34.42714312565505, y: -87.46869049097317 },
      { x: 86.19337054870495, y: -37.506037826643905 },
      { x: 61.41418694047053, y: 24.172249428651416 },
    ],
  },
  {
    position: { x: 4863, y: 2756 },
    pointVectors: [
      { x: 13.472689732306565, y: -76.82764236508238 },
      { x: 58.93909293165697, y: -49.549806502079335 },
      { x: 85.99996236625589, y: -0.08045497231046535 },
      { x: 53.665181531296845, y: 44.94494733797066 },
      { x: 11.870720010326464, y: 66.95585117401194 },
      { x: -31.94813405264843, y: 55.45553832174029 },
      { x: -54.48359002944168, y: 19.888147663966183 },
      { x: -62.04080369934221, y: -22.51529871753173 },
      { x: -38.5623675225785, y: -66.64790927743782 },
    ],
  },
  {
    position: { x: -4059, y: 260 },
    pointVectors: [
      { x: 64.81147642541289, y: -72.16974798042564 },
      { x: 48.483259903105456, y: -15.823195289445396 },
      { x: 66.5324431721273, y: 14.051121149134353 },
      { x: 44.641081225005514, y: 40.08957304664718 },
      { x: 19.546300063432497, y: 59.89108576265969 },
      { x: -14.877657687318722, y: 70.4461162998995 },
      { x: -42.76221124975695, y: 47.617153306672584 },
      { x: -75.10152024206529, y: 24.510439762082157 },
      { x: -63.59718832629819, y: -13.43121874549595 },
      { x: -61.00947767417435, y: -54.78908316375099 },
      { x: -17.06423021410793, y: -52.28586852295681 },
      { x: 11.364877400034937, y: -53.81300550686772 },
    ],
  },
  {
    position: { x: 2965, y: 4467 },
    pointVectors: [
      { x: 13.745773855661948, y: -2.655880477167678 },
      { x: 11.775819738796304, y: 5.507274233173369 },
      { x: 6.28974371679252, y: 11.377131623439585 },
      { x: -1.8447699513460554, y: 14.886128570807479 },
      { x: -7.511017857934418, y: 8.036455110170794 },
      { x: -10.800250886591535, y: 2.08676323206031 },
      { x: -10.869987451196586, y: -5.083637753698503 },
      { x: -3.870611518026161, y: -7.001311768270516 },
      { x: 1.4758159610768535, y: -11.90890285664598 },
      { x: 8.193837663201181, y: -8.76704193836814 },
    ],
  },
  {
    position: { x: 3241, y: 2208 },
    pointVectors: [
      { x: 7.755837189130288, y: 4.5658503584440435 },
      { x: 4.676690577032597, y: 13.1957783115167 },
      { x: -2.7997314114803378, y: 7.494097945955224 },
      { x: -8.702289994284412, y: 4.926474282423224 },
      { x: -14.749526281068734, y: -2.7297389040094493 },
      { x: -6.362766867382298, y: -7.714609373866059 },
      { x: 0.0677544939783823, y: -7.99971307788884 },
      { x: 7.791029101684192, y: -9.126876000949615 },
      { x: 9.862431131732718, y: -1.6530130585779705 },
    ],
  },
  {
    position: { x: -3860, y: 2361 },
    pointVectors: [
      { x: 1.4703428659577402, y: -13.92257490037411 },
      { x: 14.67376769544327, y: -3.1113568776605263 },
      { x: 4.99567988161391, y: 8.662746823060111 },
      { x: -5.356009466568592, y: 5.942487912821332 },
      { x: -10.960109699545058, y: -4.886306925883629 },
    ],
  },
  {
    position: { x: -2925, y: 3650 },
    pointVectors: [
      { x: -3.1145719355302273, y: -7.368815485436414 },
      { x: 6.6837191680938215, y: -12.301540475975163 },
      { x: 7.877121352437926, y: -1.3967674104755232 },
      { x: 10.505847741276705, y: 9.253494649974742 },
      { x: -0.6843845136330984, y: 13.98326205995937 },
      { x: -12.170637075939947, y: 8.767872784533083 },
      { x: -7.703075773970639, y: -2.1593109133394037 },
    ],
  },
  {
    position: { x: -3886, y: -3228 },
    pointVectors: [
      { x: 26.108596934275674, y: -62.788065475244025 },
      { x: 75.44967015351138, y: -39.145207544811086 },
      { x: 69.29587883613596, y: 15.462250040908199 },
      { x: 34.637358727463756, y: 45.268679905482 },
      { x: -3.28421924914185, y: 72.92608520909076 },
      { x: -40.59603443929134, y: 44.181013883837835 },
      { x: -88.2544394391618, y: 11.495821818353033 },
      { x: -74.99619474095184, y: -47.92254974828895 },
      { x: -17.065670010275472, y: -54.385318856290475 },
    ],
  },
  {
    position: { x: 326, y: -3627 },
    pointVectors: [
      { x: -14.903204395578948, y: -74.52445570914018 },
      { x: 16.664408697509938, y: -49.2574611887616 },
      { x: 56.337305575198215, y: -49.50866591342106 },
      { x: 93.15556963642524, y: -18.629005494473606 },
      { x: 75.78070952117167, y: 25.63755184232304 },
      { x: 56.10982136854381, y: 63.84894631855803 },
      { x: 10.393024117969444, y: 51.97100200768988 },
      { x: -16.984878095539056, y: 50.20472005777622 },
      { x: -71.3605870619178, y: 62.71097682366661 },
      { x: -94.13615457996656, y: 18.82510028915229 },
      { x: -57.782791009893415, y: -19.548633279771263 },
      { x: -57.4300524595685, y: -65.35127446722987 },
    ],
  },
  {
    position: { x: 4008, y: 1123 },
    pointVectors: [
      { x: 29.841947778158428, y: 84.90852815121497 },
      { x: -23.964629197568186, y: 63.63722611351836 },
      { x: -82.7941645799331, y: 46.58461453646422 },
      { x: -77.64288205569139, y: -14.580221743375379 },
      { x: -54.54567685887006, y: -66.4888647519848 },
      { x: 0.7652627856411227, y: -68.99575619463064 },
      { x: 61.216944865055545, y: -71.33362223656353 },
      { x: 74.00048055823396, y: -12.203641962563397 },
      { x: 44.74219135800652, y: 26.497854865696702 },
    ],
  },
  {
    position: { x: 3814, y: 532 },
    pointVectors: [
      { x: 0.04290265926125402, y: -7.9998849592871215 },
      { x: 10.479700510066166, y: -3.3430341337352423 },
      { x: 5.250943595991499, y: 7.309417989943923 },
      { x: -6.513269646883414, y: 8.864384835226144 },
      { x: -10.443241970323253, y: -3.4552419812914574 },
    ],
  },
  {
    position: { x: -3548, y: 335 },
    pointVectors: [
      { x: 10.500168878080778, y: 10.711977106574857 },
      { x: -3.2214078880086108, y: 11.559521236585704 },
      { x: -7.747695326982155, y: 1.9932930342172157 },
      { x: -7.700123843925909, y: -7.855449878154889 },
      { x: 2.9529572306745493, y: -10.596227800203566 },
      { x: 11.62154299047323, y: -2.9899395513258353 },
    ],
  },
  {
    position: { x: 3387, y: -532 },
    pointVectors: [
      { x: -12.97972520283897, y: -0.7257641895180893 },
      { x: -9.331386538831293, y: -10.436724834109507 },
      { x: 0.7815922040964031, y: -13.978165603057352 },
      { x: 10.436724834109507, y: -9.331386538831294 },
      { x: 12.97972520283897, y: 0.7257641895180877 },
      { x: 8.664858928914773, y: 9.69124448881597 },
      { x: -0.4466241166265151, y: 7.9875232017470585 },
      { x: -5.963842762348289, y: 5.332220879332169 },
    ],
  },
  {
    position: { x: -2095, y: -2118 },
    pointVectors: [
      { x: -8.943967383779087, y: 1.002720019694369 },
      { x: -7.06714503493491, y: -7.074988413785201 },
      { x: 1.125155822455319, y: -9.936499603743508 },
      { x: 12.705287094810968, y: -7.97343588664447 },
      { x: 10.380700097475437, y: 3.6388274878418536 },
      { x: 3.297555234240985, y: 9.440663614234431 },
      { x: -7.987523954075626, y: 12.69643497534123 },
    ],
  },
  {
    position: { x: -4583, y: -186 },
    pointVectors: [
      { x: -6.7589301602398235, y: -11.104812609359982 },
      { x: 4.318327899589562, y: -7.896331056359427 },
      { x: 13.996246819790755, y: -0.324152679299648 },
      { x: 6.239012455606, y: 10.250596254793825 },
      { x: -7.197213165982591, y: 13.160551760599054 },
      { x: -14.995978735490096, y: 0.34730644210676764 },
    ],
  },
  {
    position: { x: 4149, y: 3754 },
    pointVectors: [
      { x: -1.3870543309347936, y: -12.925791282665639 },
      { x: 11.308270022362372, y: -8.253667615147858 },
      { x: 11.887590780271287, y: 5.261671354314053 },
      { x: 1.066964869949851, y: 9.94291637128126 },
      { x: -7.269602157232953, y: 5.305929181166481 },
      { x: -8.229870540187813, y: -3.642695552986658 },
    ],
  },
  {
    position: { x: -244, y: -1878 },
    pointVectors: [
      { x: -30.331006338021766, y: 51.769006698244496 },
      { x: -65.32428362312055, y: 9.420083286580065 },
      { x: -56.83829548523732, y: -53.41730212518085 },
      { x: 6.4874163280964705, y: -79.73652506465244 },
      { x: 74.68353395901721, y: -50.22319937431627 },
      { x: 52.45197235136635, y: 16.54661888276574 },
      { x: 23.719922733008335, y: 61.59030171658615 },
    ],
  },
  {
    position: { x: -3227, y: 3136 },
    pointVectors: [
      { x: 47.75385893289113, y: -83.28006338264599 },
      { x: 72.99968061328595, y: -0.21594063592878623 },
      { x: 46.2354826745498, y: 79.53791637861409 },
      { x: -37.307702291321185, y: 65.06254951769219 },
      { x: -85.99962373619988, y: 0.2543958176694632 },
      { x: -39.70220794879808, y: -68.29886297728824 },
    ],
  },
  {
    position: { x: 1370, y: -1054 },
    pointVectors: [
      { x: -5.552355544194582, y: 7.083173576219327 },
      { x: -13.89837294988297, y: 1.683813928544755 },
      { x: -10.231250721205695, y: -8.020069119392174 },
      { x: -1.2027242346748213, y: -9.927409249916408 },
      { x: 7.403140725592779, y: -9.4442314349591 },
      { x: 13.89837294988297, y: -1.6838139285447506 },
      { x: 11.805289293698875, y: 9.253925906990974 },
      { x: 1.5635415050772692, y: 12.90563202489133 },
    ],
  },
  {
    position: { x: -2866, y: -181 },
    pointVectors: [
      { x: 7.308139071485806, y: 3.2543975343867526 },
      { x: 6.034239294864946, y: 9.197171093999927 },
      { x: 0.13231148790969122, y: 13.99937475997293 },
      { x: -5.326661362472035, y: 8.463254618026541 },
      { x: -9.96231894283965, y: 4.663925522683468 },
      { x: -10.902344512990469, y: -1.462492434191234 },
      { x: -11.42857190802559, y: -9.715335513665408 },
      { x: -2.907879705918841, y: -9.567875188144196 },
      { x: 3.5444757235928086, y: -12.507465444479998 },
      { x: 6.745741661567153, y: -5.957765473346297 },
      { x: 10.872754688984866, y: -1.668294180640099 },
    ],
  },
  {
    position: { x: -3865, y: -1224 },
    pointVectors: [
      { x: 96.94163779460379, y: -3.3643516016973436 },
      { x: 30.079944132348974, y: 82.69943748898636 },
      { x: -60.687046867212, y: 47.39285117543377 },
      { x: -67.97119374079494, y: -45.86847306648998 },
      { x: 27.03276961508002, y: -94.1978203937756 },
    ],
  },
  {
    position: { x: 3917, y: 4690 },
    pointVectors: [
      { x: 1.042272126471318, y: -7.931813715310072 },
      { x: 9.420383111311711, y: -5.679470224951718 },
      { x: 12.189156229677975, y: 4.519344024136975 },
      { x: 3.440841600555638, y: 10.447995457497372 },
      { x: -5.475674663269717, y: 8.367615370105515 },
      { x: -9.956092440376791, y: 0.9360680096403885 },
      { x: -10.409054313908705, y: -10.800536481587319 },
    ],
  },
  {
    position: { x: 3281, y: 1609 },
    pointVectors: [
      { x: 8.92780520199757, y: -1.1376705477356481 },
      { x: 5.738544130953967, y: 5.573967281666961 },
      { x: -1.1699690398318316, y: 11.942829331688325 },
      { x: -6.711162484054769, y: 4.354342443195738 },
      { x: -14.228818828054237, y: -4.747706262860964 },
      { x: -3.4397448039813443, y: -9.38978997014754 },
      { x: 5.196587606144951, y: -8.54373906739085 },
    ],
  },
  {
    position: { x: -2321, y: -946 },
    pointVectors: [
      { x: -62.460860018417215, y: -49.986407810120646 },
      { x: 31.41525520510324, y: -83.27113389643637 },
      { x: 82.90991446019194, y: 3.8660165808820475 },
      { x: 17.449264727654082, y: 63.65157626064139 },
      { x: -44.28240504321618, y: 29.12161746175068 },
    ],
  },
  {
    position: { x: -967, y: 288 },
    pointVectors: [
      { x: -11.943579188597267, y: -7.304171148440202 },
      { x: -1.612063945697575, y: -12.89966084185867 },
      { x: 8.381774334681756, y: -8.587540917076915 },
      { x: 7.95997377673897, y: 0.7992605793031127 },
      { x: 7.59163193121355, y: 11.762955607370914 },
      { x: -4.782154213006759, y: 14.217278258619746 },
      { x: -10.337902754903281, y: 3.758692143573765 },
    ],
  },
  {
    position: { x: 1045, y: -1146 },
    pointVectors: [
      { x: 27.431175895620814, y: 49.96529384466293 },
      { x: -50.29641588481626, y: 82.94136814124543 },
      { x: -78.98170765372943, y: -1.6999576761844302 },
      { x: -39.46239339370018, y: -71.87989640811156 },
      { x: 40.963060359798746, y: -67.55018642431332 },
      { x: 72.98309694585124, y: 1.570846966600729 },
    ],
  },
  {
    position: { x: -4139, y: 3651 },
    pointVectors: [
      { x: -7.354926708501589, y: -10.719377459189037 },
      { x: 6.0370044410966734, y: -12.631491494601065 },
      { x: 8.972803763074237, y: -0.699137060497291 },
      { x: 7.92069030146326, y: 11.543944956049723 },
      { x: -5.605789838161185, y: 11.729242102129566 },
      { x: -13.957694742559926, y: 1.0875465385513432 },
    ],
  },
  {
    position: { x: 3613, y: -1392 },
    pointVectors: [
      { x: -73.21730882250351, y: -54.03911258329609 },
      { x: 8.73479132901427, y: -77.50937633885707 },
      { x: 87.07417996817121, y: -37.987987349562644 },
      { x: 47.47056286294186, y: 35.03634771884029 },
      { x: -9.070744841668583, y: 80.49050619804389 },
      { x: -47.66165640363056, y: 20.79342465449745 },
    ],
  },
  {
    position: { x: 3152, y: -428 },
    pointVectors: [
      { x: -9.633902015339018, y: 10.158146088674192 },
      { x: -12.641723320399544, y: -3.03097863576541 },
      { x: -3.127348368945333, y: -10.546074728507046 },
      { x: 8.257630298862011, y: -8.706982361720742 },
      { x: 14.586603831230246, y: 3.497283041267766 },
      { x: 4.264565957652741, y: 14.381010993418695 },
    ],
  },
  {
    position: { x: -1012, y: 2633 },
    pointVectors: [
      { x: 23.95385672250993, y: 57.18577400121001 },
      { x: -9.747005953919405, y: 76.38059881235718 },
      { x: -39.96981786266654, y: 52.5206022435507 },
      { x: -58.10812519477789, y: 24.340209250292375 },
      { x: -92.25189207206778, y: -11.772357840448066 },
      { x: -74.80206986202678, y: -56.9267102892523 },
      { x: -21.635741555815446, y: -51.65166683980257 },
      { x: 10.633097404275706, y: -83.32428961348056 },
      { x: 53.2930904835554, y: -70.02746965806759 },
      { x: 51.65166683980259, y: -21.635741555815407 },
      { x: 65.46908469630615, y: 8.354576531930965 },
      { x: 62.865569352128816, y: 47.84266077501002 },
    ],
  },
  {
    position: { x: -1905, y: 4152 },
    pointVectors: [
      { x: 1.3943609326414856, y: -7.877547688813008 },
      { x: 6.789918603314683, y: -7.341457986010761 },
      { x: 12.585475317411644, y: -3.256656419523292 },
      { x: 12.34825696195527, y: 4.064547945531359 },
      { x: 7.560511633562362, y: 9.31872651378761 },
      { x: 1.1018526680719183, y: 9.939110659302612 },
      { x: -4.891206608147244, y: 9.852720330772447 },
      { x: -12.874810380956303, y: 7.696704337209521 },
      { x: -9.994754828062701, y: -0.32384552940762634 },
      { x: -7.4097348274268775, y: -5.108407754596062 },
      { x: -3.4716518565737773, y: -8.303471164925416 },
    ],
  },
  {
    position: { x: 1065, y: -1810 },
    pointVectors: [
      { x: -11.900239721609504, y: 82.14246340698718 },
      { x: -83.58894206098839, y: 33.359987486879035 },
      { x: -51.05032664626731, y: -40.235110902163676 },
      { x: 9.17608846003622, y: -63.33876696442385 },
      { x: 47.36706716789341, y: -18.90399290923148 },
      { x: 54.191885209114574, y: 42.71111772691215 },
    ],
  },
  {
    position: { x: 3794, y: -3831 },
    pointVectors: [
      { x: -1.0052071326545662, y: -12.96107860559685 },
      { x: 3.791787126685156, y: -7.044313336720956 },
      { x: 8.747872046057331, y: -4.8450732363720475 },
      { x: 14.967933927967929, y: 0.9802825755804203 },
      { x: 11.257723421548281, y: 8.322479400029973 },
      { x: 3.905885919511913, y: 10.283192849682367 },
      { x: -2.2736734596808645, y: 10.762453669992864 },
      { x: -7.028506891303596, y: 7.113374085404046 },
      { x: -12.686097623209088, y: 2.8395293790360276 },
      { x: -7.512239955715152, y: -2.7506818877792507 },
      { x: -9.061064058471842, y: -11.95395826194277 },
    ],
  },
  {
    position: { x: -647, y: -3828 },
    pointVectors: [
      { x: -4.274981690577937, y: -10.135311122270663 },
      { x: 5.274027412356221, y: -12.968601885080563 },
      { x: 9.213919202064238, y: -3.8863469914344897 },
      { x: 9.26328706077183, y: 3.7671624373973005 },
      { x: 5.440885788008286, y: 12.899486882889933 },
      { x: -4.52059492487676, y: 11.115944472926197 },
      { x: -10.135311122270657, y: 4.274981690577949 },
      { x: -8.336958354694648, y: -3.3904461936575694 },
    ],
  },
  {
    position: { x: 3936, y: 2557 },
    pointVectors: [
      { x: 12.879306667137243, y: -5.488484287472649 },
      { x: 8.77218948713313, y: 2.012136079352238 },
      { x: 9.856910766531856, y: 11.30669315673811 },
      { x: 1.151367388110136, y: 12.948913202952456 },
      { x: -5.138234177046569, y: 8.578959700443322 },
      { x: -11.03940571468906, y: 4.704415103547996 },
      { x: -9.746877207925701, y: -2.2357067548358103 },
      { x: -9.19978338209641, y: -10.55291361295556 },
      { x: -1.06280066594783, y: -11.952842956571498 },
      { x: 6.679704430160538, y: -11.15264761057632 },
    ],
  },
  {
    position: { x: -1570, y: 3460 },
    pointVectors: [
      { x: 11.917899438874478, y: -5.192655675555176 },
      { x: 8.376223535501103, y: 3.292245325506196 },
      { x: 5.991525779486741, y: 13.751422429470553 },
      { x: -4.755465470175616, y: 12.098989551279372 },
      { x: -9.167614952980363, y: 3.994350519657836 },
      { x: -13.960372559168507, y: -5.487075542510325 },
      { x: -5.9915257794867305, y: -13.751422429470558 },
      { x: 4.755465470175635, y: -12.098989551279363 },
    ],
  },
  {
    position: { x: -1987, y: -4561 },
    pointVectors: [
      { x: 10.939875501981234, y: 1.1485312364715377 },
      { x: 1.664210421704419, y: 7.8249858576415585 },
      { x: -12.989502163696615, y: 7.501522081505922 },
      { x: -6.689009024880357, y: -6.021391721609642 },
      { x: 5.286184756359174, y: -11.876710433518024 },
    ],
  },
  {
    position: { x: 2971, y: 4911 },
    pointVectors: [
      { x: 85.05952296959771, y: -22.558314480130836 },
      { x: 75.23256056191039, y: 43.6928121239465 },
      { x: 24.096381376503395, y: 90.859035899343 },
      { x: -46.706109511804954, y: 80.42101301445588 },
      { x: -86.02610845788863, y: 22.81465896285945 },
      { x: -44.101845846637055, y: -25.613027796796338 },
      { x: -17.944113791012935, y: -67.66098418036187 },
      { x: 45.19946081787602, y: -77.82678678818296 },
    ],
  },
  {
    position: { x: 1086, y: 4205 },
    pointVectors: [
      { x: 10.639964408057022, y: 2.7912644796363906 },
      { x: 6.070378437939511, y: 13.71679647804833 },
      { x: -4.626269517110893, y: 8.865530461007426 },
      { x: -12.760517494092525, y: 2.4837860783406067 },
      { x: -11.42071693357978, y: -9.724568099563294 },
      { x: 0.3536668341363974, y: -10.99431306496372 },
      { x: 8.014734315125382, y: -5.98030382655862 },
    ],
  },
  {
    position: { x: 1990, y: 1079 },
    pointVectors: [
      { x: -58.53817671897905, y: 51.54882992287583 },
      { x: -78.10350143562697, y: 11.867732028278075 },
      { x: -63.904707339269684, y: -28.56901083135871 },
      { x: -42.145936188333735, y: -64.4416019571899 },
      { x: -0.7355906031422457, y: -91.99705922726318 },
      { x: 29.898246067277753, y: -47.350764324353946 },
      { x: 52.564323956055844, y: -24.51513506066842 },
      { x: 79.2742150181363, y: 10.751689786182066 },
      { x: 66.2036408118925, y: 56.44535360195667 },
      { x: 15.916737394824683, y: 52.64653332085779 },
      { x: -23.8425133167946, y: 83.66919719190851 },
    ],
  },
  {
    position: { x: -3530, y: 3801 },
    pointVectors: [
      { x: -9.112788059905112, y: -11.91457484660073 },
      { x: 2.1800755760659665, y: -8.731968305178428 },
      { x: 9.095758459844372, y: -4.155379409893824 },
      { x: 7.1359352673101455, y: 3.61641090872695 },
      { x: 3.040798057328261, y: 14.688551568297967 },
      { x: -7.670452375755595, y: 9.228443007965392 },
      { x: -9.99794675809668, y: -0.20263420803038412 },
    ],
  },
  {
    position: { x: 25, y: -2761 },
    pointVectors: [
      { x: 21.712269655649987, y: -73.87541774095318 },
      { x: 66.71290063197308, y: -36.40589085942667 },
      { x: 58.52468158698889, y: 17.200629207722713 },
      { x: 36.40589085942667, y: 66.71290063197307 },
      { x: -18.610516847699984, y: 63.32178663510273 },
      { x: -53.545880770399464, y: 29.220517663487154 },
      { x: -91.14499591416298, y: -26.787865159568316 },
      { x: -46.46541333374172, y: -85.14672843817628 },
    ],
  },
  {
    position: { x: 3302, y: 4516 },
    pointVectors: [
      { x: -7.321573775537231, y: -54.51049951568382 },
      { x: 26.592048102261476, y: -49.283495997412885 },
      { x: 65.80628142825324, y: -31.599577917838268 },
      { x: 60.00742629235377, y: 10.959415576011779 },
      { x: 45.556494384473424, y: 47.75568886946812 },
      { x: 7.5878128219204095, y: 56.49269949807232 },
      { x: -40.8377881570444, y: 75.68536885316979 },
      { x: -88.34267917765504, y: 42.42135117737193 },
      { x: -76.73080739022285, y: -14.013678933260952 },
      { x: -51.07849370380353, y: -53.544257217282436 },
    ],
  },
  {
    position: { x: 3962, y: 3846 },
    pointVectors: [
      { x: 1.920968484138526, y: -8.792603714653955 },
      { x: 12.936263838737927, y: -1.285720768503593 },
      { x: 6.0234444056647725, y: 13.737471291757656 },
      { x: -7.4691766022804, y: 6.649165427626765 },
      { x: -10.358201534353508, y: -6.05868475609324 },
    ],
  },
  {
    position: { x: 2626, y: -1235 },
    pointVectors: [
      { x: -13.81260079675722, y: 2.2829934799341403 },
      { x: -10.099711819289865, y: -4.358419572195477 },
      { x: -8.372834629402085, y: -12.445707704613879 },
      { x: -0.31501912455988645, y: -14.996691733551154 },
      { x: 6.274250181209043, y: -10.229065678917028 },
      { x: 12.609899821476398, y: -6.081975541904909 },
      { x: 12.903695073457241, y: 1.579447197989001 },
      { x: 6.924022229681646, y: 5.7496013916509385 },
      { x: 3.0182099618836835, y: 9.533646134925824 },
      { x: -3.9227976696866813, y: 14.47797148922116 },
      { x: -8.16012980877395, y: 7.376468091435007 },
    ],
  },
  {
    position: { x: -4547, y: 4218 },
    pointVectors: [
      { x: -69.34019247021232, y: -33.48040782597954 },
      { x: -15.284724059891847, y: -67.28578758113011 },
      { x: 34.96045708360761, y: -43.74661633206882 },
      { x: 67.99996400834164, y: 0.06996330640065425 },
      { x: 37.98378909991796, y: 47.730826156823994 },
      { x: -11.39971851027785, y: 49.70962097910653 },
      { x: -58.59196212520429, y: 28.14217429976984 },
    ],
  },
  {
    position: { x: 2969, y: 2305 },
    pointVectors: [
      { x: -72.92480358266572, y: 35.2558225323084 },
      { x: -89.56226510630184, y: -16.11212801055492 },
      { x: -58.14177535205529, y: -60.62618212382449 },
      { x: -13.30292668572179, y: -97.09290469233223 },
      { x: 32.604248739322294, y: -60.8108786661104 },
      { x: 85.529090621645, y: -41.349421488509826 },
      { x: 85.62546224448636, y: 15.40390260349759 },
      { x: 44.298495506327825, y: 46.191376856247246 },
      { x: 13.167182535867498, y: 96.10216076690027 },
      { x: -30.71414736312969, y: 57.28561033764023 },
    ],
  },
  {
    position: { x: 1524, y: 2064 },
    pointVectors: [
      { x: 6.847445934280592, y: 4.136723845883864 },
      { x: 3.108194859479502, y: 7.371507628396325 },
      { x: -3.4092768899719776, y: 14.607423834732222 },
      { x: -11.344191246558264, y: 9.81373144942895 },
      { x: -10.96040742268144, y: 0.9324532850655678 },
      { x: -10.271168901420888, y: -6.205085768825798 },
      { x: -5.827865361524064, y: -13.821576803243108 },
      { x: 2.0455661339831877, y: -8.764454300839333 },
      { x: 6.8065147479349575, y: -5.888238869657371 },
      { x: 10.96040742268144, y: -0.9324532850655692 },
    ],
  },
  {
    position: { x: 1440, y: -191 },
    pointVectors: [
      { x: 4.458383125773733, y: -12.211585478708981 },
      { x: 12.13129664830094, y: -6.98796405478179 },
      { x: 7.8770794837756934, y: 1.3970035097593925 },
      { x: 7.06229757721253, y: 8.433501818989429 },
      { x: -0.010916660839016957, y: 10.999994583022126 },
      { x: -7.722570405773256, y: 9.184873778548896 },
      { x: -8.864816405492768, y: 1.554036710282703 },
      { x: -9.520816419968874, y: -5.5094513971221355 },
      { x: -4.093048819890312, y: -11.28037904318798 },
    ],
  },
  {
    position: { x: 4906, y: -3193 },
    pointVectors: [
      { x: -7.527927827889367, y: -4.932575657614273 },
      { x: 0.5077719116380076, y: -8.985664565615139 },
      { x: 8.035699739527375, y: -4.05308890800087 },
      { x: 10.873673529173537, y: 7.1248315054428275 },
      { x: -0.45135281034488756, y: 7.9872573916579 },
      { x: -9.821410792755675, y: 4.953775332001073 },
    ],
  },
  {
    position: { x: 3734, y: 3001 },
    pointVectors: [
      { x: 33.731484887596416, y: -54.38921701291401 },
      { x: 83.9641222900724, y: -39.98782524791475 },
      { x: 83.32634261487466, y: 10.616997053240771 },
      { x: 49.0351223900015, y: 41.12853963122899 },
      { x: 19.609427739428536, y: 63.01960285285945 },
      { x: -15.444230543807425, y: 55.9059544495014 },
      { x: -47.68833591288393, y: 42.68281408084459 },
      { x: -78.9925656969085, y: 12.6560090320604 },
      { x: -46.72564539332304, y: -20.43805427572374 },
      { x: -32.137081129941386, y: -48.28258502242362 },
      { x: -0.8194264965983303, y: -50.99341663603913 },
    ],
  },
  {
    position: { x: -2061, y: -1443 },
    pointVectors: [
      { x: -10.00175528166472, y: -8.304510297765422 },
      { x: 1.6854148023245918, y: -9.856945619415031 },
      { x: 14.068609066946175, y: -5.203291162470141 },
      { x: 10.77112107256201, y: 8.943318782208909 },
      { x: -1.8539562825570495, y: 10.842640181356535 },
      { x: -8.441165440167707, y: 3.1219746974820777 },
    ],
  },
  {
    position: { x: 4474, y: 1105 },
    pointVectors: [
      { x: 11.353056276099307, y: 3.886915639902943 },
      { x: 6.900143775419585, y: 9.817739855920932 },
      { x: -0.21978730691096443, y: 13.99827466296189 },
      { x: -7.204963775029082, y: 9.596275162818056 },
      { x: -11.469487155499406, y: 3.5285782391544243 },
      { x: -7.568704184066206, y: -2.5912770932686273 },
      { x: -4.600095850279727, y: -6.545159903947285 },
      { x: 0.23548640026173911, y: -14.998151424602026 },
      { x: 7.805377422948166, y: -10.395964759719565 },
      { x: 12.425277751791022, y: -3.8226264257506335 },
    ],
  },
  {
    position: { x: 1742, y: -4970 },
    pointVectors: [
      { x: -12.901157290831444, y: -53.465504211194215 },
      { x: 67.31092921527625, y: -41.35503364979975 },
      { x: 47.19157097055808, y: 40.21138681183204 },
      { x: -25.18677526360101, y: 61.00513381528522 },
      { x: -89.73064313514558, y: -6.957850426184204 },
    ],
  },
  {
    position: { x: 1794, y: -4282 },
    pointVectors: [
      { x: 8.679541966592438, y: -2.380241846989646 },
      { x: 10.497118183017754, y: 3.287933979227385 },
      { x: 6.411951310673263, y: 7.673778755577686 },
      { x: 1.1207868057508408, y: 8.929940477744228 },
      { x: -5.611701997530774, y: 11.726414656275342 },
      { x: -11.91146119284214, y: 7.356432032678322 },
      { x: -7.99871213563641, y: -0.14354153135182335 },
      { x: -12.471263308790428, y: -8.334722039925364 },
      { x: -5.187349596396416, y: -11.920209904392035 },
      { x: 1.2804159095101095, y: -7.896868689466313 },
      { x: 8.688101420344465, y: -9.670413316389766 },
    ],
  },
  {
    position: { x: 71, y: 1289 },
    pointVectors: [
      { x: -6.790677097371054, y: 4.229267614994377 },
      { x: -8.994974268057408, y: 0.30072897596523357 },
      { x: -10.586987614010226, y: -5.649397601584974 },
      { x: -7.929876778114464, y: -12.732519557570722 },
      { x: -0.4009719679536455, y: -11.993299024076544 },
      { x: 3.7662650677233187, y: -7.057991742673483 },
      { x: 11.034850283227966, y: -6.8725598743658605 },
      { x: 12.992740609416257, y: -0.4343862986164385 },
      { x: 11.469236581844404, y: 6.120180735050402 },
      { x: 7.929876778114444, y: 12.732519557570736 },
      { x: 0.40097196795362566, y: 11.993299024076546 },
      { x: -7.061747001981244, y: 13.233734517512769 },
    ],
  },
  {
    position: { x: 392, y: 308 },
    pointVectors: [
      { x: 0.5654154194873061, y: -9.9840024741286 },
      { x: 6.958468106030348, y: -8.519373311303973 },
      { x: 7.736058868184125, y: -2.037987533816079 },
      { x: 8.38856487440135, y: 3.260671609953976 },
      { x: 5.411018729897485, y: 8.409570518444959 },
      { x: -0.6219569614360353, y: 10.98240272154146 },
      { x: -6.3258800963912245, y: 7.744884828458158 },
      { x: -14.505110377845234, y: 3.82122662590515 },
      { x: -13.048878693513212, y: -5.072155837706183 },
      { x: -6.493222475876983, y: -10.09148462213395 },
    ],
  },
  {
    position: { x: 1018, y: -2523 },
    pointVectors: [
      { x: 3.032569826520557, y: 14.690252559002417 },
      { x: -3.460485432055106, y: 10.441505666068203 },
      { x: -8.217621126619791, y: 7.312366444546668 },
      { x: -7.834801364801288, y: 1.617370574144301 },
      { x: -14.238416817365733, y: -4.718843770984229 },
      { x: -9.30664820215031, y: -10.45879052478882 },
      { x: -2.021713217680377, y: -9.79350170600161 },
      { x: 2.8313062625905405, y: -8.543050090419438 },
      { x: 6.7235081945071045, y: -5.982845272810908 },
      { x: 7.83480136480129, y: -1.617370574144295 },
      { x: 7.593822302595055, y: 2.5167166778582644 },
      { x: 5.982845272810902, y: 6.723508194507109 },
    ],
  },
  {
    position: { x: -1789, y: -19 },
    pointVectors: [
      { x: -52.976039276751905, y: -1.5935063689985807 },
      { x: -57.5713209692851, y: -76.82150090860992 },
      { x: 23.15940575204112, y: -89.03730636768121 },
      { x: 46.59394510142864, y: -20.736544550263297 },
      { x: 85.20156793619415, y: 44.23452069610443 },
      { x: 16.993503833618625, y: 86.34362065292831 },
      { x: -32.98244448329556, y: 38.8993361885049 },
    ],
  },
  {
    position: { x: -1848, y: 916 },
    pointVectors: [
      { x: 5.329738658291285, y: -8.46131702717227 },
      { x: 13.587292244513767, y: -6.354957864705007 },
      { x: 7.928590515827685, y: 1.0665141500830047 },
      { x: 6.855022912368377, y: 5.831694511109492 },
      { x: 4.3566002583850585, y: 14.353398001471263 },
      { x: -4.0950274702813045, y: 14.430202701890279 },
      { x: -8.99721032897185, y: 7.940416002719395 },
      { x: -7.907898649013656, y: 1.2104292449077698 },
      { x: -12.787171481337335, y: -5.699846095016353 },
      { x: -8.223946855084744, y: -12.544588399973183 },
      { x: -0.13630781845041978, y: -14.999380659834902 },
    ],
  },
  {
    position: { x: 1841, y: -443 },
    pointVectors: [
      { x: -48.77152393821579, y: 36.63793734292425 },
      { x: -60.55634738323788, y: 7.343622512127053 },
      { x: -75.43347555619857, y: -32.15261677550353 },
      { x: -31.832961953688308, y: -42.375258503695676 },
      { x: -10.232916615259013, y: -84.38179553401999 },
      { x: 25.486830370825995, y: -59.79482818479155 },
      { x: 70.35891977972116, y: -52.854729281595624 },
      { x: 72.46907145862895, y: -8.788269563692975 },
      { x: 57.035066883955, y: 24.310515122941762 },
      { x: 49.85161966332309, y: 66.36125388314615 },
      { x: 6.7416862406411395, y: 55.59271235182495 },
      { x: -34.11314218864408, y: 80.03307772425943 },
    ],
  },
  {
    position: { x: 4850, y: -4211 },
    pointVectors: [
      { x: 17.0471751018595, y: 83.2730077578956 },
      { x: -28.565621541494597, y: 52.763673734379985 },
      { x: -66.0280727808567, y: 26.101601576261363 },
      { x: -60.71727263533627, y: -20.233951757534793 },
      { x: -31.935402264889838, y: -51.972397310299904 },
      { x: 8.650053442389254, y: -58.36245861376823 },
      { x: 49.378057326099615, y: -43.79277856793767 },
      { x: 74.97186577714263, y: -2.0541036717045915 },
      { x: 53.26860109260963, y: 42.26648953528585 },
    ],
  },
  {
    position: { x: 2957, y: 3938 },
    pointVectors: [
      { x: -61.09485634613976, y: 59.096687961716995 },
      { x: -86.53411188787639, y: -24.735550929310026 },
      { x: -21.117259113800234, y: -84.39823083169826 },
      { x: 57.501041266955035, y: -55.620412199263086 },
      { x: 51.920467132725854, y: 14.841330557585962 },
      { x: 15.777262556287592, y: 63.05614947195844 },
    ],
  },
  {
    position: { x: -7, y: 1231 },
    pointVectors: [
      { x: -11.278027638954683, y: -9.889696283252295 },
      { x: -2.428138825198039, y: -10.728659834553703 },
      { x: 4.7364463127197505, y: -11.02570071817313 },
      { x: 9.45322568507857, y: -5.62463546791886 },
      { x: 11.94970691831367, y: 1.0974992329867106 },
      { x: 6.014948074109167, y: 5.2745046844012204 },
      { x: 3.311098397997328, y: 14.629990683482323 },
      { x: -3.1576308751464994, y: 7.350467145448754 },
      { x: -8.593841531889607, y: 5.113304970835328 },
      { x: -12.945515828173143, y: -1.1889575024022683 },
    ],
  },
  {
    position: { x: -367, y: 4457 },
    pointVectors: [
      { x: 56.928918371196936, y: -11.094965213356733 },
      { x: 89.19731546916077, y: 35.49420957135139 },
      { x: 53.5209408515643, y: 74.82986629924817 },
      { x: 4.1216721773240454, y: 82.89759838778608 },
      { x: -28.895498029803523, y: 50.28966289019664 },
      { x: -59.488011122167855, y: 30.824933620834184 },
      { x: -80.64906064329757, y: -7.531866790757155 },
      { x: -59.05025237682283, y: -46.23924409236736 },
      { x: -22.37418570310014, y: -64.21367310879506 },
      { x: 16.829121128200477, y: -70.00557607828362 },
      { x: 44.060155532476436, y: -42.18652266368948 },
    ],
  },
  {
    position: { x: 3094, y: -1719 },
    pointVectors: [
      { x: -0.32171504836968573, y: -7.993528596787059 },
      { x: 5.424791384084754, y: -5.879765168708681 },
      { x: 7.993528596787059, y: -0.32171504836968623 },
      { x: 6.614735814797266, y: 6.102890307095349 },
      { x: 0.3619294294158975, y: 8.992719671385442 },
      { x: -7.459088153116536, y: 8.084677106974436 },
      { x: -13.988675044377352, y: 0.563001334646965 },
      { x: -8.084677106974437, y: -7.459088153116536 },
    ],
  },
  {
    position: { x: -2205, y: -2496 },
    pointVectors: [
      { x: 44.428692149849205, y: 72.4644141206836 },
      { x: 1.6633252575975317, y: 62.978038625281414 },
      { x: -27.66373283045534, y: 50.97762142239659 },
      { x: -47.741261067744475, y: 29.270667769312432 },
      { x: -54.98082737127743, y: 1.4521093518708887 },
      { x: -49.2197724078312, y: -26.70981100871548 },
      { x: -45.996763637490965, y: -75.02198167788417 },
      { x: -1.4521093518708676, y: -54.98082737127743 },
      { x: 42.9264819782928, y: -79.10320565544296 },
      { x: 48.59378358681136, y: -29.793358265192975 },
      { x: 83.9707181670419, y: -2.217767010129983 },
      { x: 67.67718706076784, y: 36.725990136983896 },
    ],
  },
  {
    position: { x: -1393, y: -4505 },
    pointVectors: [
      { x: 41.36472608659856, y: 33.13547096059859 },
      { x: -8.921018828707524, y: 58.321654838128914 },
      { x: -66.1485869616846, y: 25.794659194733505 },
      { x: -57.75452321525085, y: -46.26461983177913 },
      { x: 10.584259627280044, y: -69.19518370625465 },
      { x: 70.80693815616941, y: -27.611184490137347 },
    ],
  },
  {
    position: { x: -2601, y: -419 },
    pointVectors: [
      { x: 7.010597639493686, y: -86.71707744577837 },
      { x: 43.6803986227266, y: -57.23655105052806 },
      { x: 73.33159752223449, y: -26.579631390164387 },
      { x: 63.38374927181751, y: 14.404871684516127 },
      { x: 60.24490707797316, y: 61.372234529682714 },
      { x: 19.535894923788128, y: 93.99121666159402 },
      { x: -33.66457992983336, y: 87.76500474646977 },
      { x: -66.09705146813633, y: 48.5301945928361 },
      { x: -75.8533590503239, y: 4.718889782845502 },
      { x: -48.02594985438504, y: -26.805002156017327 },
      { x: -25.439028583136388, y: -47.63250806693229 },
    ],
  },
  {
    position: { x: 3777, y: 3710 },
    pointVectors: [
      { x: -33.206315210500684, y: -40.01675436790033 },
      { x: 19.130011403775303, y: -92.03283470420449 },
      { x: 64.24968608595461, y: -32.49581262034065 },
      { x: 80.92235184436375, y: 37.04825194225765 },
      { x: 14.003918426451701, y: 56.2840143264967 },
      { x: -58.38341633409526, y: 76.20614605896101 },
      { x: -88.98315380969373, y: 1.731570986239622 },
    ],
  },
  {
    position: { x: -1989, y: 976 },
    pointVectors: [
      { x: 2.515099118037916, y: -79.96045445360127 },
      { x: 53.84804425558342, y: -78.26485884385616 },
      { x: 59.02351813352332, y: -24.743166877779483 },
      { x: 68.94005684693175, y: 12.135425906898279 },
      { x: 46.29164381422785, y: 42.732700745174775 },
      { x: 20.36567138956094, y: 78.39795551449296 },
      { x: -27.122992992089827, y: 82.66403843964463 },
      { x: -69.8367589569738, y: 56.76994890243905 },
      { x: -75.52928283269594, y: 8.445557102916393 },
      { x: -57.3518222410102, y: -28.403670284587665 },
      { x: -31.863388317120858, y: -53.18575453025336 },
    ],
  },
  {
    position: { x: -3761, y: -3097 },
    pointVectors: [
      { x: -26.929452109188702, y: 52.49575801051845 },
      { x: -80.91150673201632, y: 26.044732257308354 },
      { x: -70.29093021747386, y: -36.058079942811986 },
      { x: -23.287054724181626, y: -72.34440601921457 },
      { x: 42.904550818029406, y: -83.63730937269044 },
      { x: 59.96970498961208, y: -19.303742731887404 },
      { x: 56.944551062257325, y: 29.211609067594487 },
      { x: 18.078108272719952, y: 56.16210467281131 },
    ],
  },
  {
    position: { x: 4405, y: 1590 },
    pointVectors: [
      { x: -5.367001530944057, y: -9.601838082723752 },
      { x: 3.8111584547019186, y: -13.471268360223327 },
      { x: 10.474732453880456, y: -5.85491076102988 },
      { x: 12.509034905921661, y: 3.5389328507946374 },
      { x: 3.9032738406865874, y: 6.983154969253638 },
      { x: -2.4500304351655178, y: 8.660101088714997 },
      { x: -12.220521196193872, y: 6.830729221201518 },
      { x: -8.660101088714992, y: -2.4500304351655324 },
    ],
  },
  {
    position: { x: 4160, y: 1702 },
    pointVectors: [
      { x: -64.41084688050364, y: -61.41858679696493 },
      { x: 7.859478607484007, y: -88.65229041608852 },
      { x: 55.867051447108175, y: -36.984761221429686 },
      { x: 72.3116037672625, y: 23.388714385498606 },
      { x: 28.562640202316643, y: 75.79693651245415 },
      { x: -37.357899929168696, y: 62.716722753044245 },
      { x: -63.40925190158447, y: 8.675642528447488 },
    ],
  },
  {
    position: { x: -1686, y: 3555 },
    pointVectors: [
      { x: 63.49857468037181, y: 63.78033406592697 },
      { x: 7.305720831711309, y: 85.68912674971719 },
      { x: -46.60646013012552, y: 66.248304688792 },
      { x: -73.45372716264876, y: 19.507689917444235 },
      { x: -72.42960093880505, y: -33.969882364315744 },
      { x: -39.958037673368764, y: -86.18790649095523 },
      { x: 13.569747950930827, y: -50.19822646815531 },
      { x: 71.37651994701, y: -49.74326487328796 },
      { x: 87.64794012002885, y: 7.863751821861982 },
    ],
  },
  {
    position: { x: 371, y: -1515 },
    pointVectors: [
      { x: 8.968911022466756, y: 0.7474189394672489 },
      { x: 9.0431799163385, y: 10.687417695623765 },
      { x: -0.6643723906375542, y: 7.972365353303783 },
      { x: -9.924030717364927, y: 8.397238493742892 },
      { x: -7.972365353303783, y: -0.6643723906375555 },
      { x: -6.459414225956071, y: -7.633869782588404 },
      { x: 0.7474189394672492, y: -8.968911022466756 },
      { x: 9.924030717364925, y: -8.397238493742893 },
    ],
  },
  {
    position: { x: -3837, y: 2335 },
    pointVectors: [
      { x: -10.283703860800474, y: -3.9045402934734117 },
      { x: -2.080497363634558, y: -12.832440559765303 },
      { x: 11.622658656338391, y: -9.482289056880846 },
      { x: 13.088350368291517, y: 4.969414918966147 },
      { x: 2.240535622375692, y: 13.81955137205494 },
      { x: -11.622658656338391, y: 9.482289056880848 },
    ],
  },
  {
    position: { x: -2163, y: -1106 },
    pointVectors: [
      { x: -0.47324026517888906, y: -14.992532929809204 },
      { x: 6.165968171153844, y: -10.294699437687228 },
      { x: 12.545023431218471, y: -6.2146912320870396 },
      { x: 13.913461028912158, y: 1.5542207684053873 },
      { x: 8.536371688227554, y: 6.937604658700799 },
      { x: 2.4949095173947247, y: 7.601014833560925 },
      { x: -3.769813926573843, y: 14.51855719274508 },
      { x: -8.81655513024638, y: 8.140537797671984 },
      { x: -12.80290392353073, y: 2.2551388260684595 },
      { x: -13.834278755272994, y: -5.797648775271084 },
      { x: -4.5353014953929405, y: -6.590223087717635 },
    ],
  },
  {
    position: { x: 2315, y: 4786 },
    pointVectors: [
      { x: -88.9157450250765, y: 19.364665931422188 },
      { x: -66.70005551604723, y: -54.287223120695884 },
      { x: 0.5179778855894925, y: -51.99742011782931 },
      { x: 44.12818736791106, y: -34.47757357504345 },
      { x: 92.40298374206552, y: 22.061019821476403 },
      { x: 37.81499283317485, y: 80.56690584245453 },
      { x: -42.069502237788285, y: 85.17720928431929 },
    ],
  },
  {
    position: { x: 4384, y: 4460 },
    pointVectors: [
      { x: 5.1881632717185004, y: 53.75019034260243 },
      { x: -50.95932121037332, y: 74.18320282771563 },
      { x: -90.57542172785575, y: 25.14145936140296 },
      { x: -66.43420686941744, y: -30.25716704570089 },
      { x: -36.18055240586145, y: -75.80875693220878 },
      { x: 23.764723351384955, y: -91.97955166248713 },
      { x: 79.77009201092923, y: -56.92743117836853 },
      { x: 90.7211343301718, y: 7.118692706313725 },
      { x: 54.932826687787276, y: 53.957247447303374 },
    ],
  },
  {
    position: { x: 2474, y: 3858 },
    pointVectors: [
      { x: 89.98545601185315, y: -1.6179327361921496 },
      { x: 39.521531367749596, y: 47.77079189575975 },
      { x: -11.272726623703138, y: 53.83238462549522 },
      { x: -62.5116331198042, y: 31.50072578044827 },
      { x: -59.96913203299479, y: -27.56271400296491 },
      { x: -21.84102678210866, y: -88.34007895119413 },
      { x: 46.91872089975796, y: -61.05434979696873 },
    ],
  },
  {
    position: { x: 1767, y: 3373 },
    pointVectors: [
      { x: -16.9719024737161, y: -62.745155402012266 },
      { x: 34.54710136291066, y: -90.63938320300275 },
      { x: 70.33976830864307, y: -45.91641312522582 },
      { x: 81.89755702442525, y: 4.097578971906979 },
      { x: 63.06938456343435, y: 50.82570934861242 },
      { x: 23.76066346320255, y: 87.84321756281717 },
      { x: -21.725496733376797, y: 57.00002448848627 },
      { x: -82.90044122090077, y: 54.1157726118733 },
      { x: -71.91005007022704, y: -3.597874219235388 },
      { x: -53.725772035518155, y: -43.29597463029947 },
    ],
  },
  {
    position: { x: 2253, y: -896 },
    pointVectors: [
      { x: 10.472031376362766, y: 10.739485967795375 },
      { x: 1.601828756587916, y: 7.837993661299301 },
      { x: -3.9737433997064158, y: 10.257161566110272 },
      { x: -9.696399149938479, y: 7.069642390182997 },
      { x: -8.984450461180716, y: 0.5288193553470144 },
      { x: -11.330369583832237, y: -6.373595931165493 },
      { x: -4.68145178948065, y: -8.83651566754501 },
      { x: 1.0069118367375296, y: -11.957680734700933 },
      { x: 8.530524831717864, y: -11.100907444684193 },
      { x: 14.119219100335455, y: -5.064351093350701 },
      { x: 9.743891909310644, y: 2.2486819383075405 },
    ],
  },
  {
    position: { x: -4885, y: 112 },
    pointVectors: [
      { x: 6.99046163377513, y: -7.150765423835265 },
      { x: 10.94657047396668, y: -1.0828641920762074 },
      { x: 9.081611168432264, y: 6.2067977722337915 },
      { x: 2.6975136966571718, y: 9.629300070947366 },
      { x: -4.535497337796826, y: 10.021440210809915 },
      { x: -13.521886542440793, y: 6.492964217779008 },
      { x: -9.687975330432309, y: -2.478534647112079 },
      { x: -5.245423475048081, y: -7.313380378963925 },
      { x: 0.6068647001388706, y: -7.9769489929248865 },
    ],
  },
  {
    position: { x: -4905, y: -4037 },
    pointVectors: [
      { x: -9.725571795184226, y: 7.02945611386237 },
      { x: -14.999954372103957, y: -0.03699776749173563 },
      { x: -7.268082755868905, y: -5.308010272582474 },
      { x: -3.9867133349051915, y: -12.37360565014455 },
      { x: 2.490894817968162, y: -7.60233141909897 },
      { x: 7.29417884638817, y: -5.272092085396778 },
      { x: 9.999969581402638, y: 0.024665178327822525 },
      { x: 11.305906509129407, y: 8.256904868461625 },
      { x: 2.45336205224935, y: 7.614526553935107 },
      { x: -3.7363422269522415, y: 11.403497128648455 },
    ],
  },
  {
    position: { x: -1982, y: 2429 },
    pointVectors: [
      { x: 0.9420435334851051, y: 8.950561657293854 },
      { x: -5.033668864533807, y: 6.2178917457787035 },
      { x: -8.950561657293854, y: 0.9420435334851057 },
      { x: -6.217891745778704, y: -5.033668864533807 },
      { x: -1.4654010520879368, y: -13.923095911345996 },
      { x: 6.921294688733987, y: -8.549601150445715 },
      { x: 7.956054806483426, y: -0.8373720297645357 },
      { x: 9.326837618668055, y: 7.550503296800713 },
    ],
  },
  {
    position: { x: -2629, y: 3474 },
    pointVectors: [
      { x: -23.501468204120275, y: -45.26235734305852 },
      { x: 39.293011416959956, y: -39.90061721059782 },
      { x: 80.50170582377207, y: 40.24270566777116 },
      { x: -10.717353826370802, y: 71.1978814780354 },
      { x: -49.322953884148276, y: 8.200379268191313 },
    ],
  },
  {
    position: { x: 209, y: 2947 },
    pointVectors: [
      { x: -79.03692866000453, y: -45.10170626476735 },
      { x: -28.087401594685065, y: -75.97432376572287 },
      { x: 23.609147210324004, y: -65.8984686316856 },
      { x: 61.30786623473993, y: -35.80985252333826 },
      { x: 67.02566511776, y: 11.469970162205769 },
      { x: 39.44536617603643, y: 46.530238418026634 },
      { x: 0.25233019268677975, y: 49.9993632906846 },
      { x: -44.72394510294084, y: 53.84950078161481 },
      { x: -55.09945720855494, y: 10.002490456012634 },
    ],
  },
  {
    position: { x: 4065, y: -2260 },
    pointVectors: [
      { x: -44.27837351816603, y: -84.05013764763133 },
      { x: 25.45861088368342, y: -82.1453536840228 },
      { x: 53.96903575268959, y: -28.431376680085556 },
      { x: 71.63838984071755, y: 22.20227693344484 },
      { x: 35.888786956829314, y: 68.12484840913277 },
      { x: -29.0109751930345, y: 93.60749605853763 },
      { x: -75.20275473735434, y: 39.61749209520119 },
      { x: -82.14535368402277, y: -25.458610883683477 },
    ],
  },
  {
    position: { x: -3565, y: -620 },
    pointVectors: [
      { x: 1.9774744771671695, y: -14.86908183756322 },
      { x: 9.834940261551857, y: -1.809405994161146 },
      { x: 7.140016561278575, y: 13.191670231804148 },
      { x: -10.33963747722048, y: 10.867009562876888 },
      { x: -13.530263953553048, y: -6.475488965876092 },
    ],
  },
  {
    position: { x: -4133, y: 1874 },
    pointVectors: [
      { x: 85.82609850303068, y: -43.0102408241116 },
      { x: 65.88498264107783, y: 3.8947480515268658 },
      { x: 81.83103147866755, y: 53.92292914092594 },
      { x: 34.497797327672785, y: 68.83968317430588 },
      { x: -5.783110743176336, y: 97.82921664887314 },
      { x: -46.219653549365155, y: 70.14088412457215 },
      { x: -75.09783619015187, y: 37.63396072109759 },
      { x: -98.82747396161675, y: -5.842122077290287 },
      { x: -50.93564204284412, y: -33.56427222037222 },
      { x: -41.6661707983582, y: -83.14403292481093 },
      { x: 5.074974733807567, y: -85.85012889594991 },
      { x: 33.564272220372125, y: -50.93564204284419 },
    ],
  },
  {
    position: { x: -2525, y: -2012 },
    pointVectors: [
      { x: -1.8359514606303726, y: 12.869704046100251 },
      { x: -8.642127445615111, y: 11.014246829163854 },
      { x: -13.919384277029284, y: 5.590236251572015 },
      { x: -9.89977234315404, y: -1.4122703543310529 },
      { x: -8.654051080057318, y: -6.7902429929832975 },
      { x: -3.354141750943213, y: -8.351630566217569 },
      { x: 1.8359514606303677, y: -12.869704046100253 },
      { x: 8.024832628071174, y: -10.227514912795009 },
      { x: 13.919384277029286, y: -5.59023625157201 },
      { x: 12.869704046100251, y: 1.8359514606303786 },
      { x: 8.65405108005731, y: 6.790242992983308 },
      { x: 4.472189001257599, y: 11.135507421623434 },
    ],
  },
  {
    position: { x: 79, y: -1861 },
    pointVectors: [
      { x: 12.719411001467227, y: -2.6863699997867903 },
      { x: 7.05870736511812, y: 3.7649236823111325 },
      { x: 5.227665201931763, y: 12.987359875529428 },
      { x: -3.4127422466532558, y: 10.45720757936401 },
      { x: -10.184809852125221, y: 6.345837082375583 },
      { x: -10.890955570993988, y: -1.5450199838950376 },
      { x: -5.345335485854401, y: -5.952091106801516 },
      { x: -0.47045972814399617, y: -13.992093040149307 },
      { x: 8.016868766523736, y: -10.23375860475203 },
    ],
  },
  {
    position: { x: 1956, y: 3646 },
    pointVectors: [
      { x: 2.507117806540351, y: 11.735176193995908 },
      { x: -4.235393538531385, y: 11.227708651980892 },
      { x: -8.830430914231778, y: 6.559229365480348 },
      { x: -14.965661357797112, y: 1.0143865750976184 },
      { x: -8.758889517052449, y: -4.825127400190458 },
      { x: -5.711743113518397, y: -10.553482392327906 },
      { x: 0.7505160622665741, y: -9.97179651017207 },
      { x: 5.420281055029743, y: -7.184744482894689 },
      { x: 10.320684876239797, y: -3.805714609026157 },
      { x: 7.810790742255043, y: 1.72960919883739 },
      { x: 7.044697468736216, y: 7.097340176008302 },
    ],
  },
  {
    position: { x: -3454, y: 1331 },
    pointVectors: [
      { x: 44.80737789918951, y: -74.5741167282538 },
      { x: 74.98859353538674, y: 1.3079906668453392 },
      { x: 46.05795525490368, y: 83.08829495023527 },
      { x: -46.8674872278878, y: 78.00281175024253 },
      { x: -71.98904979397126, y: -1.255671040171517 },
      { x: -32.48297896924781, y: -58.59911328069226 },
    ],
  },
  {
    position: { x: -4069, y: 4698 },
    pointVectors: [
      { x: -54.64154903652275, y: -12.259735677790127 },
      { x: -17.300086691098876, y: -55.35979588546605 },
      { x: 67.06899444343023, y: -72.81998341353234 },
      { x: 79.03509771354184, y: 17.732831962517782 },
      { x: 19.686305545043613, y: 62.99562980070272 },
      { x: -60.97181313039111, y: 66.19998492139304 },
    ],
  },
  {
    position: { x: -2200, y: 850 },
    pointVectors: [
      { x: -0.3281657743640288, y: -7.993266367670732 },
      { x: 5.541040500161959, y: -8.324474168112056 },
      { x: 11.250958896308164, y: -4.173239019464877 },
      { x: 14.44398162507533, y: 4.046158031328765 },
      { x: 6.2047697212437445, y: 7.842246661916267 },
      { x: 0.45122793975054093, y: 10.990741255547256 },
      { x: -7.757456700226743, y: 11.654263835356879 },
      { x: -13.126118712359524, y: 4.868778856042359 },
      { x: -12.518117408398618, y: -3.506670293818261 },
      { x: -4.963815776994997, y: -6.2737973295330125 },
    ],
  },
  {
    position: { x: -1915, y: 911 },
    pointVectors: [
      { x: 64.82954480239577, y: 35.68094898841901 },
      { x: 15.231977999946297, y: 88.70167329993923 },
      { x: -43.227006180499004, y: 48.54303180345353 },
      { x: -82.87750226239118, y: -4.507728779257428 },
      { x: -50.469426596824945, y: -70.86492065181261 },
      { x: 18.984718038840565, y: -66.33687120286667 },
      { x: 50.77618528081848, y: -21.13714759204735 },
    ],
  },
  {
    position: { x: 3623, y: 272 },
    pointVectors: [
      { x: 6.207514606247019, y: -96.80117128637045 },
      { x: 76.54172543507515, y: -19.554136836525643 },
      { x: 31.018828170040557, y: 49.00849211062812 },
      { x: -35.74779380390555, y: 43.105628845354424 },
      { x: -70.62919535604755, y: -28.0627290789273 },
    ],
  },
  {
    position: { x: 2349, y: 1765 },
    pointVectors: [
      { x: 4.5948022014141205, y: 7.738720354805435 },
      { x: -2.4242181087896983, y: 14.802809414466434 },
      { x: -9.855838452474757, y: 8.477172193527744 },
      { x: -11.999106027669722, y: 0.1464736725154297 },
      { x: -6.1906666378200175, y: -5.067114226004995 },
      { x: -2.227871303642491, y: -11.791377758956173 },
      { x: 3.9151353949672654, y: -6.976511652615117 },
      { x: 9.354478703134824, y: -3.534646827138043 },
      { x: 11.325568336696115, y: 3.9662957341613367 },
    ],
  },
  {
    position: { x: 1072, y: 4143 },
    pointVectors: [
      { x: 8.58452414208652, y: -6.877931756998878 },
      { x: 13.996406237589415, y: 0.3171946285297302 },
      { x: 11.269264762353362, y: 9.899680384536705 },
      { x: 1.6642015560135046, y: 10.87338186494718 },
      { x: -7.792394705405813, y: 12.817120766972725 },
      { x: -11.366405666825571, y: 3.8477034991219785 },
      { x: -12.112130370481857, y: -4.721895582120704 },
      { x: -6.72350451254402, y: -12.279840677704259 },
      { x: 2.1550777021976106, y: -10.786827156188732 },
    ],
  },
  {
    position: { x: 1298, y: 2365 },
    pointVectors: [
      { x: 71.99149578945278, y: 24.356201140514543 },
      { x: 47.39397989965591, y: 66.91644543212836 },
      { x: -0.7726552904997311, y: 63.99533579724434 },
      { x: -44.81320998976499, y: 60.1396392607507 },
      { x: -50.60004798617601, y: 15.768168688743945 },
      { x: -72.93875231299822, y: -24.676677471310786 },
      { x: -33.52257114853711, y: -47.33114433004201 },
      { x: 0.676073379187258, y: -55.99591882258879 },
      { x: 43.61819105670458, y: -58.53591554713069 },
      { x: 85.92460978784605, y: -26.776135509187842 },
    ],
  },
  {
    position: { x: 1988, y: -2968 },
    pointVectors: [
      { x: -50.406111690297166, y: -80.52467885229527 },
      { x: 4.482822634895276, y: -64.84523345030127 },
      { x: 45.59483636083617, y: -54.42527810887669 },
      { x: 49.47529631119355, y: -12.377198993293975 },
      { x: 81.61825820467936, y: 32.9007587698869 },
      { x: 30.774257663549854, y: 49.162435509822366 },
      { x: -3.862124116217462, y: 55.86666266487494 },
      { x: -46.23701715465076, y: 55.19183132167777 },
      { x: -62.08664635130172, y: 15.53217128570225 },
      { x: -74.19841654970851, y: -29.90978069989717 },
    ],
  },
  {
    position: { x: 60, y: 1509 },
    pointVectors: [
      { x: 6.537300609483746, y: -6.185765978538426 },
      { x: 9.916321451919396, y: -1.290956568674246 },
      { x: 10.537533370445354, y: 5.741114044046727 },
      { x: 5.150501408663545, y: 10.838465538966059 },
      { x: -1.4692313547490112, y: 7.8639277225965385 },
      { x: -6.537300609483739, y: 6.185765978538432 },
      { x: -12.891217887495214, y: 1.6782435392765325 },
      { x: -12.293788932186255, y: -6.697966384721169 },
      { x: -4.29208450721963, y: -9.032054615805045 },
      { x: 2.3875009514671413, y: -12.778882549219377 },
    ],
  },
  {
    position: { x: -4225, y: -1238 },
    pointVectors: [
      { x: 66.61255713864259, y: 17.993533045265913 },
      { x: 13.35678168276645, y: 50.25531198867354 },
      { x: -48.88913529035632, y: 48.691400170474004 },
      { x: -55.02776459279172, y: -14.864222950437012 },
      { x: -16.43911591725108, y: -61.85269167836742 },
      { x: 68.01966649093046, y: -67.74455675892042 },
    ],
  },
  {
    position: { x: 1801, y: 421 },
    pointVectors: [
      { x: -4.372414154563744, y: 11.175061273253522 },
      { x: -10.936511098736558, y: 8.740293186570579 },
      { x: -9.88674502397258, y: 1.5007574190899189 },
      { x: -10.243806167149064, y: -4.008046308350094 },
      { x: -6.2430665618361285, y: -7.811793641954684 },
      { x: -2.1010603867258815, y: -13.841443033561614 },
      { x: 4.008046308350103, y: -10.24380616714906 },
      { x: 8.592973006150158, y: -6.8673732180197335 },
      { x: 12.852768531164356, y: -1.950984644816879 },
      { x: 10.243806167149057, y: 4.008046308350111 },
      { x: 7.491679874203338, y: 9.374152370345634 },
      { x: 2.1010603867258584, y: 13.841443033561616 },
    ],
  },
  {
    position: { x: 3697, y: 4253 },
    pointVectors: [
      { x: -2.8025317666474585, y: -9.599261205787238 },
      { x: 3.7125091774887196, y: -10.354577519486831 },
      { x: 6.610727982570814, y: -4.505360755861313 },
      { x: 14.993204796829405, y: 0.4514531208572569 },
      { x: 8.700559995774285, y: 6.7305464681504255 },
      { x: 2.242025413317968, y: 7.679408964629791 },
      { x: -4.050010011805885, y: 11.295902748531084 },
      { x: -11.568773969498931, y: 7.884381322757288 },
      { x: -11.994563837463524, y: -0.36116249668581474 },
      { x: -7.118639996542592, y: -5.5068107466685365 },
    ],
  },
  {
    position: { x: 246, y: 953 },
    pointVectors: [
      { x: 10.447233973780653, y: -7.736620857783022 },
      { x: 14.967121746522407, y: -0.9926059765969738 },
      { x: 12.252601528696738, y: 6.773016741377387 },
      { x: 6.171076799355136, y: 11.441932141752142 },
      { x: -0.6120217769589558, y: 7.97655497972201 },
      { x: -6.034145858440953, y: 7.97427637839697 },
      { x: -12.203705567125137, y: 4.479907413208326 },
      { x: -12.688431227977919, y: -2.8290834156798548 },
      { x: -7.034361250860521, y: -7.107584807259918 },
      { x: -1.6600246345321568, y: -7.825874916758278 },
      { x: 3.5431072798931025, y: -9.351277495784654 },
    ],
  },
  {
    position: { x: -1729, y: -2618 },
    pointVectors: [
      { x: -57.59090549880328, y: 74.29190806425629 },
      { x: -87.99166328776764, y: 1.211276951041111 },
      { x: -57.71149595246418, y: -70.35895987668316 },
      { x: 11.499424616381924, y: -53.78441441060922 },
      { x: 76.06746193399464, y: -37.930742609659994 },
      { x: 66.20046695431196, y: 30.765210466223838 },
      { x: 22.176410358942228, y: 91.34663006149597 },
    ],
  },
  {
    position: { x: -1374, y: -2778 },
    pointVectors: [
      { x: 10.939530110981138, y: 1.1518163703199331 },
      { x: 2.285058250201424, y: 10.760042230083783 },
      { x: -12.991754244659043, y: 7.4976210658037195 },
      { x: -5.9441782504997045, y: -5.354133443077999 },
      { x: 3.2552314031547858, y: -7.307767683220022 },
    ],
  },
  {
    position: { x: 4788, y: -4852 },
    pointVectors: [
      { x: -10.981648107757575, y: -6.957255553548719 },
      { x: -3.2834714598896984, y: -14.636215876109842 },
      { x: 4.281388032953054, y: -6.757937297081586 },
      { x: 7.805981800591916, y: -1.7511847786078396 },
      { x: 10.981648107757579, y: 6.957255553548712 },
      { x: 1.75118477860784, y: 7.805981800591916 },
      { x: -8.027602561786987, y: 12.671132432027969 },
      { x: -14.636215876109848, y: 3.2834714598896753 },
    ],
  },
  {
    position: { x: 3513, y: -2522 },
    pointVectors: [
      { x: -3.4932339401702155, y: 9.370022232590639 },
      { x: -9.167011155383877, y: 6.079959414097069 },
      { x: -14.986334032463619, y: -0.6401501913010224 },
      { x: -10.181537664084589, y: -8.083086712069031 },
      { x: -2.41332773313988, y: -8.670400755008844 },
      { x: 4.1918807282042545, y: -11.244026679108767 },
      { x: 10.833740456362762, y: -7.185406580296538 },
      { x: 13.987245096966044, y: 0.5974735118809524 },
      { x: 8.615147254225421, y: 6.839534910212255 },
      { x: 2.681475259044313, y: 9.633778616676492 },
    ],
  },
  {
    position: { x: 1247, y: 3138 },
    pointVectors: [
      { x: -4.976143374143026, y: -8.673983924355202 },
      { x: 0.038535542214582635, y: -13.999946964613338 },
      { x: 6.530964366469314, y: -11.240396098176792 },
      { x: 13.010975886532808, y: -7.464215061214528 },
      { x: 13.999946964613338, y: 0.038535542214594216 },
      { x: 9.511104390764974, y: 5.526200617781736 },
      { x: 7.464215061214517, y: 13.010975886532815 },
      { x: -0.0357830034849911, y: 12.999950752855243 },
      { x: -4.019054994750359, y: 6.91716682964725 },
      { x: -7.806585531919689, y: 4.478529036728711 },
      { x: -7.999969694064765, y: -0.02202030983691 },
      { x: -6.9171668296472575, y: -4.019054994750347 },
    ],
  },
  {
    position: { x: 1064, y: 3624 },
    pointVectors: [
      { x: 87.34033610262121, y: -17.10747466697416 },
      { x: 50.13721820440105, y: 17.18311237012304 },
      { x: 44.02854238655166, y: 50.50235098800475 },
      { x: 17.10747466697409, y: 87.34033610262122 },
      { x: -28.20624106039072, y: 82.30071667514888 },
      { x: -73.86911040036514, y: 64.3999575206278 },
      { x: -86.35898401158052, y: 16.915255850491313 },
      { x: -80.40874617686964, y: -27.557821725668948 },
      { x: -37.45711814975298, y: -42.9646866614368 },
      { x: -12.87866070435146, y: -65.75059009972605 },
      { x: 21.72204771317423, y: -63.38101169235611 },
      { x: 57.28624888191564, y: -49.94282419967075 },
    ],
  },
  {
    position: { x: 173, y: -3663 },
    pointVectors: [
      { x: 74.21375843206236, y: -52.662302070717466 },
      { x: 83.62271316544943, y: 38.35677049555883 },
      { x: 8.21979201659609, y: 87.61526704407116 },
      { x: -41.59232615423275, y: 29.514037424248254 },
      { x: -89.9853109062988, y: -41.27522042456881 },
      { x: -6.818691104676181, y: -72.68084652519542 },
    ],
  },
  {
    position: { x: 3447, y: 3762 },
    pointVectors: [
      { x: 65.62145405214821, y: 31.981631729506876 },
      { x: 45.09440883146893, y: 84.74959759279295 },
      { x: -13.332420506815293, y: 95.06969319099252 },
      { x: -36.11113911372618, y: 37.4163818655561 },
      { x: -95.52135192969418, y: 16.87220571008755 },
      { x: -85.39778267060385, y: -41.61993170278291 },
      { x: -42.2760082795021, y: -79.4527477432434 },
      { x: 11.110350422346102, y: -79.2247443258271 },
      { x: 40.9722539944201, y: -42.45320250130402 },
      { x: 55.14634750580282, y: -9.740654842937126 },
    ],
  },
  {
    position: { x: 3790, y: -1812 },
    pointVectors: [
      { x: 12.998855028835886, y: 0.17253387872535467 },
      { x: 3.2600426198857075, y: 10.505813729384732 },
      { x: -7.3507205735861945, y: 5.192967075676164 },
      { x: -7.210302754367699, y: -5.3862356233604896 },
      { x: 3.216120446899968, y: -9.468715291476027 },
    ],
  },
  {
    position: { x: 4634, y: -1211 },
    pointVectors: [
      { x: 83.99998679408553, y: 0.04710194748821703 },
      { x: 56.07461714673084, y: 70.39628762830864 },
      { x: -21.1914198704872, y: 92.6062833930437 },
      { x: -86.51635402832147, y: 41.60433253455872 },
      { x: -54.04352588327821, y: -26.063332674534127 },
      { x: -13.984375882810212, y: -61.42830968835359 },
      { x: 48.04246416549474, y: -60.174094400390885 },
    ],
  },
  {
    position: { x: 1571, y: 2536 },
    pointVectors: [
      { x: 9.170172786673144, y: -6.075189796422767 },
      { x: 12.370426378327785, y: 3.996567429478965 },
      { x: 4.23525457233107, y: 11.227761072785114 },
      { x: -7.671973812760524, y: 12.889562359378877 },
      { x: -10.89796625879922, y: 1.4947680161395387 },
      { x: -5.791583648993499, y: -5.518836728578872 },
      { x: 1.1436863087724647, y: -12.949593878849113 },
    ],
  },
  {
    position: { x: 3490, y: 3281 },
    pointVectors: [
      { x: -9.999900962344345, y: -0.04450554240374182 },
      { x: -10.684465333814302, y: -9.04666792418736 },
      { x: -1.6926351757496585, y: -9.85570830340544 },
      { x: 4.030794729202416, y: -6.910332398013429 },
      { x: 14.1180824023449, y: -5.067519045903948 },
      { x: 8.443450215821853, y: 3.115790181147941 },
      { x: 6.449829816093719, y: 11.287147351896689 },
      { x: -1.7802939821720931, y: 9.840251690736464 },
      { x: -11.533464262745253, y: 9.590578819861609 },
    ],
  },
  {
    position: { x: -3605, y: 1489 },
    pointVectors: [
      { x: -14.94075996558412, y: -1.3318001542269116 },
      { x: -3.3503315231619473, y: -14.621056004437824 },
      { x: 10.296112968551864, y: -6.163607526345113 },
      { x: 9.043612985103188, y: 7.887525858954316 },
      { x: -5.0990904928797125, y: 11.958230477182807 },
    ],
  },
  {
    position: { x: -136, y: -1114 },
    pointVectors: [
      { x: -7.138636467915122, y: 5.480863926330622 },
      { x: -13.859809381409336, y: -5.7363476107186635 },
      { x: -1.7004710102329248, y: -12.888304711767077 },
      { x: 9.518181957220154, y: -7.307818568440839 },
      { x: 13.859809381409343, y: 5.736347610718649 },
      { x: 1.1772491609304954, y: 8.922672492761821 },
    ],
  },
  {
    position: { x: -3238, y: -824 },
    pointVectors: [
      { x: 48.445340319517385, y: -64.91570689229336 },
      { x: 87.59810645687035, y: -20.653613368386843 },
      { x: 55.372840286045594, y: 27.8899365122276 },
      { x: 19.750605625674023, y: 45.933795591253876 },
      { x: -20.154166177810232, y: 67.0358828216442 },
      { x: -49.33143559161734, y: 32.36370594462429 },
      { x: -81.43442416685141, y: -9.614289397211104 },
      { x: -49.34848566832018, y: -52.42830306469587 },
      { x: -3.5330266134987247, y: -61.89925462352765 },
    ],
  },
  {
    position: { x: -4770, y: -1123 },
    pointVectors: [
      { x: 13.375850423342898, y: 4.133597156516053 },
      { x: 0.15877760138945743, y: 10.99885401636448 },
      { x: -12.304460771775693, y: 4.195264606176006 },
      { x: -5.994016327988217, y: -8.004484259451738 },
      { x: 8.064649606473997, y: -11.443837936846133 },
    ],
  },
  {
    position: { x: -3376, y: -2710 },
    pointVectors: [
      { x: -2.70562365199776, y: -13.736069330552692 },
      { x: 4.848102695963853, y: -14.194925158287663 },
      { x: 9.789903650803774, y: -8.553232518058826 },
      { x: 10.792625902577118, y: -2.1258471551410882 },
      { x: 13.248596814401814, y: 4.524895849566273 },
      { x: 5.921468666348413, y: 6.777625604402618 },
      { x: 2.7056236519977372, y: 13.736069330552697 },
      { x: -4.201689003168681, y: 12.30226847051597 },
      { x: -8.283764627603192, y: 7.237350592203622 },
      { x: -13.736069330552692, y: 2.7056236519977626 },
      { x: -12.30226847051598, y: -4.201689003168659 },
      { x: -9.869114443914052, y: -11.296042674004335 },
    ],
  },
  {
    position: { x: 3263, y: 508 },
    pointVectors: [
      { x: 77.16765169611249, y: 60.40822404033634 },
      { x: -27.775990459420285, y: 76.08872685226238 },
      { x: -91.94086169239895, y: -3.2981739279737123 },
      { x: -15.933948458614308, y: -55.768353808573394 },
      { x: 43.13758211099198, y: -29.03702825044989 },
    ],
  },
  {
    position: { x: 2860, y: -1827 },
    pointVectors: [
      { x: -21.22820109920116, y: -53.97558223948931 },
      { x: 8.306952805288558, y: -55.38045264432847 },
      { x: 51.08052134510302, y: -64.14655360276555 },
      { x: 63.281717108366806, y: -24.88823577147717 },
      { x: 58.34726260741749, y: 8.751968134143352 },
      { x: 70.40475395425484, y: 56.0639868421863 },
      { x: 30.7442912471188, y: 78.17153289857079 },
      { x: -10.8287063354655, y: 72.19237576849962 },
      { x: -54.81812046791543, y: 68.84020386638255 },
      { x: -51.183741778826075, y: 20.13019069751835 },
      { x: -54.39151598996547, y: -8.15861436233692 },
      { x: -60.23517838308482, y: -47.965855409425885 },
    ],
  },
  {
    position: { x: 785, y: -3459 },
    pointVectors: [
      { x: -8.013324698721851, y: -69.53982044320257 },
      { x: 51.83746591551045, y: -23.703947507921388 },
      { x: 37.885917413033276, y: 41.239025955674826 },
      { x: -47.16557491319406, y: 83.61464311415722 },
      { x: -55.87022163725115, y: -11.292401613670739 },
    ],
  },
  {
    position: { x: 1935, y: -705 },
    pointVectors: [
      { x: -10.85646758852481, y: -1.771189289519989 },
      { x: -6.689016398911927, y: -6.02138352997775 },
      { x: -3.9529216048158693, y: -14.469775768344855 },
      { x: 4.197705992425029, y: -13.355870035349962 },
      { x: 9.984058954681032, y: -8.325777248368675 },
      { x: 11.908042970890582, y: -1.4827382113587608 },
      { x: 9.917702682276465, y: 4.758064050216876 },
      { x: 4.721644457524651, y: 7.661988881271412 },
      { x: -0.20812470731664962, y: 10.998030919496651 },
      { x: -6.1210700720182, y: 9.139611653316738 },
      { x: -9.173289943880352, y: 3.9813002405625717 },
    ],
  },
  {
    position: { x: -2412, y: -2144 },
    pointVectors: [
      { x: -7.648670900030759, y: 70.58681061971154 },
      { x: -53.72505244953093, y: 73.44806831561434 },
      { x: -45.74246944986392, y: 20.189761975522796 },
      { x: -53.68574328823132, y: -5.8172989943895645 },
      { x: -78.29079809466586, y: -57.26736360004942 },
      { x: -33.51500487936788, y: -75.93249928677409 },
      { x: 7.64867090003072, y: -70.58681061971154 },
      { x: 30.10964477940744, y: -41.163203121937705 },
      { x: 49.40186700585304, y: -21.804942933564604 },
      { x: 52.69156285696777, y: 5.709571235234243 },
      { x: 62.9554871276694, y: 46.05004495674084 },
      { x: 25.035304849648202, y: 56.72066211783129 },
    ],
  },
  {
    position: { x: 538, y: 3447 },
    pointVectors: [
      { x: -5.385458257145437, y: 8.425962221642347 },
      { x: -10.903145865716589, y: 5.012126318331102 },
      { x: -12.872242552477758, y: -1.8180681148353268 },
      { x: -7.573767454567113, y: -6.529781508147114 },
      { x: -3.6935498803129008, y: -12.464256467260315 },
      { x: 2.514097329185365, y: -8.641719424939867 },
      { x: 9.803530409371154, y: -8.537610409976264 },
      { x: 12.863035262268385, y: -1.8821062248555758 },
      { x: 13.659943044530223, y: 6.197253909611125 },
      { x: 5.427324616541146, y: 8.39905634620262 },
      { x: 0.03732497793040301, y: 14.999953561462199 },
    ],
  },
  {
    position: { x: 4462, y: -3625 },
    pointVectors: [
      { x: -0.2402079336853143, y: 60.99952704856485 },
      { x: -51.111775338510824, y: 50.710811684941476 },
      { x: -85.99933321600946, y: -0.3386538081464844 },
      { x: -52.82376217181403, y: -53.241432644282106 },
      { x: 0.283524118448215, y: -71.99944176224048 },
      { x: 48.27223226414911, y: -47.893544369111396 },
      { x: 84.99934096931167, y: 0.3347159731680265 },
      { x: 50.00649485598396, y: 50.401889569920385 },
    ],
  },
  {
    position: { x: -4105, y: 167 },
    pointVectors: [
      { x: -5.3301750034918545, y: 8.461042159932227 },
      { x: -12.677422130195513, y: 2.8780146165071994 },
      { x: -7.614937943939005, y: -4.797157503142669 },
      { x: -1.9924716575819077, y: -8.776676859366123 },
      { x: 4.797157503142668, y: -7.614937943939005 },
      { x: 11.702235812488166, y: -2.6566288767758777 },
      { x: 10.999354807911896, y: 6.92922750453941 },
      { x: 1.7710859178505856, y: 7.801490541658777 },
    ],
  },
  {
    position: { x: -1218, y: -4138 },
    pointVectors: [
      { x: -7.817553493171745, y: -11.614037083693088 },
      { x: 0.46616708074996704, y: -12.991639167280818 },
      { x: 4.9313421514940385, y: -6.299354299045112 },
      { x: 7.692207161580101, y: -2.19771449085995 },
      { x: 10.333001916115888, y: 3.7721441384901215 },
      { x: 7.817553493171747, y: 11.614037083693086 },
      { x: -0.3944490683268938, y: 10.992925449237616 },
      { x: -9.246266534051331, y: 11.81128931070958 },
      { x: -7.692207161580103, y: 2.197714490859944 },
      { x: -12.211729537227864, y: -4.457988527306517 },
    ],
  },
  {
    position: { x: -3863, y: 1593 },
    pointVectors: [
      { x: 65.67423792216738, y: 6.54938724939607 },
      { x: 58.47367068008975, y: 42.0098778526719 },
      { x: 23.872433742201803, y: 52.85931239832944 },
      { x: -5.457822707830044, y: 54.728531601806154 },
      { x: -29.75699681230925, y: 41.41885006506358 },
      { x: -68.35255913577082, y: 30.869526390778226 },
      { x: -50.748274758038434, y: -5.060890147260561 },
      { x: -52.78873047508105, y: -37.92558417255098 },
      { x: -21.402871630939593, y: -47.39110766746776 },
      { x: 5.854755268399468, y: -58.70878844557387 },
      { x: 56.59664099596072, y: -78.77702855512094 },
      { x: 77.46623368720694, y: -34.98546324288197 },
    ],
  },
  {
    position: { x: 4519, y: 2544 },
    pointVectors: [
      { x: 13.429031299450951, y: -3.9574130891741284 },
      { x: 6.217767596585455, y: 9.07410414943822 },
      { x: -6.708590026445333, y: 8.717500780446091 },
      { x: -10.363904249517228, y: -3.6863923701688006 },
      { x: 0.3584985702931621, y: -12.995055935820274 },
    ],
  },
  {
    position: { x: -4642, y: -4183 },
    pointVectors: [
      { x: -2.962390673086968, y: 8.498484659044067 },
      { x: -8.661582493128877, y: 6.780633356458918 },
      { x: -7.965435660331651, y: 0.7428558010252535 },
      { x: -13.317316982458873, y: -6.902830462115702 },
      { x: -3.9846869629496418, y: -6.937021681334084 },
      { x: 0.6472457675058769, y: -12.983877422266652 },
      { x: 8.145966652752778, y: -11.38609798360438 },
      { x: 13.937799156898572, y: -5.544164018313083 },
      { x: 14.722624147601078, y: 2.871295562716179 },
      { x: 8.66649599722525, y: 8.300111272150435 },
      { x: 1.8688942878568036, y: 7.7786396073359905 },
    ],
  },
  {
    position: { x: 2361, y: -2370 },
    pointVectors: [
      { x: -18.685174360381165, y: -65.38244610843307 },
      { x: 57.23789978197405, y: -38.53339887096251 },
      { x: 74.80895312156497, y: 58.554423683061685 },
      { x: -32.22847226776578, y: 88.30246641677599 },
      { x: -61.96028156269772, y: -2.2188980758972847 },
    ],
  },
  {
    position: { x: 1783, y: -3848 },
    pointVectors: [
      { x: -0.08569282453336294, y: -11.999694026925166 },
      { x: 7.407043563118314, y: -13.043607846530328 },
      { x: 6.899462301793936, y: -4.049372784287008 },
      { x: 14.999617533656458, y: -0.10711603066669127 },
      { x: 11.304460133659612, y: 6.419437754702548 },
      { x: 7.59257397053813, y: 12.936491815863636 },
      { x: 0.07855175582223116, y: 10.999719524681403 },
      { x: -4.444226137870994, y: 7.826164707918194 },
      { x: -10.349193452690905, y: 6.074059176430513 },
      { x: -7.999796017950111, y: 0.057128549688910096 },
      { x: -9.565312420788914, y: -5.431831946286753 },
      { x: -4.049372784287021, y: -6.899462301793928 },
    ],
  },
  {
    position: { x: -2142, y: -884 },
    pointVectors: [
      { x: 63.28142837255632, y: 43.868677015941834 },
      { x: 5.626268129517599, y: 83.81136621565582 },
      { x: -53.15866619552581, y: 48.56085057237633 },
      { x: -91.85078872638351, y: -14.575068107602771 },
      { x: -24.662786536527783, y: -43.494217549619904 },
      { x: 23.098909341381347, y: -57.53642661165747 },
      { x: 48.84954726174047, y: -14.653386377318533 },
    ],
  },
  {
    position: { x: -3412, y: -1157 },
    pointVectors: [
      { x: -4.974430017474436, y: 13.086445124679555 },
      { x: -6.434184694752238, y: 4.754079018465727 },
      { x: -12.972423379728234, y: 0.8463047069940796 },
      { x: -12.24530877896737, y: -6.786192813923333 },
      { x: -6.632516440584168, y: -12.3292224274437 },
      { x: 0.6206017168929837, y: -7.975892019642034 },
      { x: 6.646992231349474, y: -8.764558989269212 },
      { x: 10.330284033920472, y: -3.7795808998522276 },
      { x: 14.636977699119292, y: 3.280073754579992 },
      { x: 9.134725117582605, y: 9.24969172600933 },
      { x: 2.2709575143928844, y: 10.763027081998006 },
    ],
  },
  {
    position: { x: -2343, y: 2577 },
    pointVectors: [
      { x: -45.578523071710954, y: 20.55719422979489 },
      { x: -57.837007746776116, y: -29.662780296178582 },
      { x: -17.027323917026234, y: -84.29751028485163 },
      { x: 43.074833366088505, y: -51.31821051521291 },
      { x: 57.98174465169669, y: 1.4550900815560048 },
      { x: 57.953199308230495, y: 76.53382709586991 },
      { x: -21.974959168497175, y: 86.2444268897584 },
    ],
  },
  {
    position: { x: 31, y: -2387 },
    pointVectors: [
      { x: 93.6524932895801, y: -15.943980075412641 },
      { x: 69.36515627268679, y: 61.94735745183761 },
      { x: -5.016703326957647, y: 89.86007282285772 },
      { x: -60.337377790761934, y: 42.84157841787425 },
      { x: -73.03665163751022, y: -21.015411430209415 },
      { x: -35.617895239221795, y: -85.9090538809957 },
      { x: 27.55552134353763, y: -49.89682598608695 },
    ],
  },
  {
    position: { x: -385, y: -4186 },
    pointVectors: [
      { x: -30.131769286970982, y: 54.185574460706356 },
      { x: -68.05496584073211, y: 11.38075675940693 },
      { x: -43.14646150128485, y: -38.76058384387604 },
      { x: 4.7522783732247404, y: -80.86047149419412 },
      { x: 69.45051912625769, y: -49.00638114667635 },
      { x: 63.37275122431585, y: 18.436225271485867 },
      { x: 33.08404728637106, y: 80.46394108638455 },
    ],
  },
  {
    position: { x: -3585, y: 1743 },
    pointVectors: [
      { x: -4.1853278343232985, y: -12.307844284001916 },
      { x: 4.315785181791267, y: -6.736022436470273 },
      { x: 12.930583989867959, y: -1.3416399222482955 },
      { x: 7.008479676238587, y: 7.133106800528832 },
      { x: -1.5693234177286688, y: 12.90493022106545 },
      { x: -7.662418527221996, y: 4.720947183954201 },
      { x: -11.291233259707353, y: -4.063010149492426 },
    ],
  },
  {
    position: { x: 688, y: 246 },
    pointVectors: [
      { x: -1.5525629123629197, y: -12.906957364272774 },
      { x: 5.356551039018724, y: -9.60767198474154 },
      { x: 13.610166440860311, y: -6.305820283839349 },
      { x: 10.7927043498084, y: 2.1254488508611167 },
      { x: 10.202964198028997, y: 10.995431850261202 },
      { x: 1.3137070796917025, y: 10.921271615923114 },
      { x: -4.869591853653392, y: 8.734247258855941 },
      { x: -9.980788723297565, y: 4.624268208148848 },
      { x: -12.755014231591742, y: -2.5118940964722385 },
      { x: -9.522766584827057, y: -10.262403060243797 },
    ],
  },
  {
    position: { x: 4574, y: 894 },
    pointVectors: [
      { x: -5.224185424532702, y: 85.84117826923219 },
      { x: -46.422814469104466, y: 41.096499811627574 },
      { x: -63.88180708407977, y: -3.8877658973266724 },
      { x: -62.307596488596644, y: -70.38297677573902 },
      { x: 5.224185424532711, y: -85.84117826923219 },
      { x: 50.16658982951611, y: -44.41073366740399 },
      { x: 62.88365384839102, y: 3.8270195551809354 },
      { x: 34.468032100074744, y: 38.93526374828116 },
    ],
  },
  {
    position: { x: -1567, y: 2167 },
    pointVectors: [
      { x: 53.21832619607329, y: 72.57967867721887 },
      { x: 0.38889594485905926, y: 88.99915033270864 },
      { x: -54.918987334236945, y: 76.28830074252488 },
      { x: -51.28364613801212, y: 16.911169054537762 },
      { x: -90.47778366115338, y: -28.961537662312168 },
      { x: -36.07019886622746, y: -49.19289332567057 },
      { x: -0.3364605365634481, y: -76.99926489459062 },
      { x: 54.91898733423693, y: -76.28830074252488 },
      { x: 93.07032076898493, y: -30.690640136012984 },
      { x: 59.04865881043695, y: 18.90121405329846 },
    ],
  },
  {
    position: { x: 3650, y: -1301 },
    pointVectors: [
      { x: 14.999093542761505, y: 0.16490268490879892 },
      { x: 3.923592990451985, y: 6.971758604919999 },
      { x: -6.113885348531223, y: 10.325715759452962 },
      { x: -12.999214403726638, y: -0.1429156602542835 },
      { x: -6.866287733290986, y: -12.200577558609991 },
      { x: 7.132866239953081, y: -12.046668386028463 },
    ],
  },
  {
    position: { x: 2513, y: -147 },
    pointVectors: [
      { x: -8.594236963131564, y: 12.293863958151771 },
      { x: -12.026297284946388, y: 4.936413031148338 },
      { x: -14.753067062651185, y: -2.710537261303883 },
      { x: -6.567385623513274, y: -6.153815570202861 },
      { x: -3.4188505196218975, y: -13.576135721348733 },
      { x: 4.782528253311935, y: -14.217152440143318 },
      { x: 8.587107251135253, y: -6.874706470642972 },
      { x: 11.935288623134714, y: -1.2445422782979625 },
      { x: 7.142302716179297, y: 3.6038190729360755 },
      { x: 7.612716943090018, y: 12.924648573341951 },
      { x: -0.5444763773863331, y: 13.989408331822624 },
    ],
  },
  {
    position: { x: -3439, y: -3076 },
    pointVectors: [
      { x: -39.05126675904512, y: 65.19968224243043 },
      { x: -79.9896994948847, y: -1.283734675874384 },
      { x: -40.341219265406785, y: -72.53679085940026 },
      { x: 42.648093960536066, y: -71.20491613318063 },
      { x: 91.98815441911741, y: 1.4762948772554483 },
      { x: 32.078559897793404, y: 57.67985779181222 },
    ],
  },
  {
    position: { x: 2483, y: -567 },
    pointVectors: [
      { x: -14.120192503971754, y: 5.0616364597608055 },
      { x: -9.946640979598268, y: -4.697268698187961 },
      { x: -3.7118667371579246, y: -10.354807836245953 },
      { x: 5.551317552403954, y: -11.755121157707043 },
      { x: 12.237500170108852, y: -4.386751598459367 },
      { x: 11.755121157707043, y: 5.551317552403953 },
      { x: 5.061636459760808, y: 14.120192503971753 },
      { x: -4.697268698187969, y: 9.946640979598264 },
    ],
  },
  {
    position: { x: 4051, y: 1219 },
    pointVectors: [
      { x: -50.38292026553837, y: -80.53919136368582 },
      { x: 43.683303199152405, y: -52.11304080180815 },
      { x: 72.3350551118227, y: 29.182868295792517 },
      { x: -4.36298886554603, y: 62.84874165931345 },
      { x: -72.76302738305134, y: 18.18080982941409 },
    ],
  },
  {
    position: { x: 4793, y: -2549 },
    pointVectors: [
      { x: -0.2200839125457135, y: -61.99960937837785 },
      { x: 48.92625733201295, y: -76.72823042063233 },
      { x: 58.12170552636165, y: -26.79304661114337 },
      { x: 90.11915516325286, y: 12.630830244348795 },
      { x: 59.12941308720021, y: 50.86956366987273 },
      { x: 19.67443457147285, y: 66.13559271899537 },
      { x: -17.256139505647006, y: 59.55019436879823 },
      { x: -59.52019794744941, y: 51.945606515820366 },
      { x: -54.4120513701565, y: 8.020515300867554 },
      { x: -66.5103642299287, y: -30.0893909875594 },
      { x: -49.469751511829415, y: -76.37894791994619 },
    ],
  },
  {
    position: { x: -3818, y: -2482 },
    pointVectors: [
      { x: -28.647615379083863, y: -73.6227827040793 },
      { x: 20.128003671205004, y: -45.76967848053947 },
      { x: 75.48665062063827, y: -29.372871464630297 },
      { x: 58.585188455090524, y: 25.7638446991424 },
      { x: 30.823383635723154, y: 79.21438645375619 },
      { x: -39.04832712213769, y: 88.79317625224658 },
      { x: -54.98410353848958, y: 21.395054523619653 },
      { x: -65.90833701197684, y: -28.984325286535192 },
    ],
  },
  {
    position: { x: -825, y: -2750 },
    pointVectors: [
      { x: 24.975928193629755, y: -90.62120618744075 },
      { x: 51.586554121886, y: -41.16828189067071 },
      { x: 91.90592013565448, y: -4.1595485354421236 },
      { x: 65.11166369110462, y: 42.94730784783241 },
      { x: 32.35645694506211, y: 86.12235304473712 },
      { x: -16.473484553245154, y: 59.77143386831199 },
      { x: -52.368168578278215, y: 41.792043737499064 },
      { x: -56.94171138839463, y: 2.5771115926108874 },
      { x: -59.26830925728755, y: -39.09306227174488 },
      { x: -27.43264827950919, y: -73.01677758140755 },
    ],
  },
  {
    position: { x: -3051, y: -4972 },
    pointVectors: [
      { x: 61.05511079885284, y: -27.59118419603994 },
      { x: 56.38724832849554, y: 8.335359976664268 },
      { x: 64.77087892457682, y: 56.57502314040898 },
      { x: 17.787508064506724, y: 61.47848857002836 },
      { x: -20.55822335651848, y: 69.00260467854454 },
      { x: -61.425340455799606, y: 52.800829064410614 },
      { x: -62.39377515117889, y: 8.718762663596905 },
      { x: -55.386743928910654, y: -25.55990213113654 },
      { x: -34.92478516879849, y: -54.8202460858511 },
      { x: 0.34460532739123023, y: -86.99931750978472 },
      { x: 38.62178234002904, y: -59.57648805426031 },
    ],
  },
  {
    position: { x: 516, y: 804 },
    pointVectors: [
      { x: 12.127772817479821, y: 4.681573078314335 },
      { x: 1.8549463322274304, y: 11.855765437311755 },
      { x: -9.339920883907787, y: 7.534313365021605 },
      { x: -11.194867216135222, y: -4.321452072290146 },
      { x: -2.0095251932463962, y: -12.843745890421067 },
      { x: 10.896574364559076, y: -8.790032259191884 },
    ],
  },
  {
    position: { x: 2164, y: -46 },
    pointVectors: [
      { x: 13.939628741315284, y: -1.2987496118562925 },
      { x: 7.990019342235438, y: 4.14241365760393 },
      { x: 4.980082325509795, y: 8.671723013977381 },
      { x: -0.6484082395700096, y: 12.983819420912234 },
      { x: -4.655420595491058, y: 6.505924921106736 },
      { x: -8.362977289226755, y: 3.3257496688532524 },
      { x: -9.81491134352272, y: -1.915075799750242 },
      { x: -8.665752835556308, y: -8.300887169034876 },
      { x: -2.5687720326398873, y: -10.695859490678023 },
      { x: 4.938585914910185, y: -14.16369899288497 },
      { x: 9.449661319853483, y: -7.396208551688149 },
    ],
  },
  {
    position: { x: 320, y: -1524 },
    pointVectors: [
      { x: -39.94810839012447, y: 85.0890629637609 },
      { x: -53.61312777222181, y: 19.355426383301875 },
      { x: -47.97574826680136, y: -22.523933454006347 },
      { x: -25.807235177735873, y: -71.4841703629624 },
      { x: 35.69830962521757, y: -76.03703498889274 },
      { x: 84.65230700877126, y: -30.56119955258196 },
      { x: 59.74338463413001, y: 28.04867184838523 },
      { x: 29.88206178474681, y: 82.77114463079857 },
    ],
  },
  {
    position: { x: -1916, y: -2420 },
    pointVectors: [
      { x: -3.376682746631415, y: 9.412651785156068 },
      { x: -12.660795244006291, y: 5.975304493441959 },
      { x: -12.23644732070289, y: -4.389687570620839 },
      { x: -3.8412671743555458, y: -8.139082656861188 },
      { x: 3.039014471968273, y: -8.471386606640461 },
      { x: 9.947767691719228, y: -4.694882101990112 },
      { x: 9.412651785156068, y: 3.3766827466314138 },
      { x: 3.4144597105382637, y: 7.234740139432166 },
    ],
  },
  {
    position: { x: -2939, y: -1019 },
    pointVectors: [
      { x: 7.443567768341235, y: -8.098969000935334 },
      { x: 10.908020650953938, y: -1.419537064807543 },
      { x: 6.740719594065024, y: 4.30844512024789 },
      { x: 4.48926683877553, y: 14.312459021784843 },
      { x: -3.456536044696398, y: 8.30977488092876 },
      { x: -9.764676242720139, y: 5.064691291170362 },
      { x: -12.687641653160258, y: -2.8326223329263 },
      { x: -7.898522846161903, y: -10.325373448387156 },
      { x: 0.4961868008806995, y: -10.988803331511205 },
    ],
  },
  {
    position: { x: -1287, y: -1556 },
    pointVectors: [
      { x: 12.982896239247914, y: -0.6666372633766962 },
      { x: 10.057129149968853, y: 6.546308368908905 },
      { x: 3.2164236605587675, y: 8.405630186714006 },
      { x: -2.3385640574732003, y: 8.690864062283708 },
      { x: -10.889355229541083, y: 8.79897395636936 },
      { x: -10.985527587055927, y: 0.5640776843956674 },
      { x: -10.895223245799592, y: -7.091834066317979 },
      { x: -2.8590432538300163, y: -7.471671277079117 },
      { x: 2.5984045083035543, y: -9.656515624759676 },
      { x: 7.000299790419266, y: -5.656483257666018 },
    ],
  },
  {
    position: { x: -3065, y: 3642 },
    pointVectors: [
      { x: -9.580816345995101, y: -8.786805912520947 },
      { x: 0.827317114648338, y: -11.971447130226569 },
      { x: 7.406608530749333, y: -5.112939474727939 },
      { x: 9.572668816197735, y: 2.8920601196025415 },
      { x: 3.7073577327748803, y: 9.287383842677889 },
      { x: -4.454702405768904, y: 7.820206293700745 },
      { x: -12.843342777954502, y: 2.012099969674452 },
    ],
  },
  {
    position: { x: 4502, y: 4665 },
    pointVectors: [
      { x: 11.730084355167346, y: 2.5308340563257574 },
      { x: 5.962781245797989, y: 9.24365943848862 },
      { x: -3.163542570407196, y: 14.662605443959182 },
      { x: -11.764657467167336, y: 7.588994312833807 },
      { x: -10.752577325570067, y: -2.3199312182986076 },
      { x: -5.962781245797992, y: -9.24365943848862 },
      { x: 2.952639732380045, y: -13.685098414361905 },
      { x: 9.243659438488619, y: -5.962781245797992 },
    ],
  },
  {
    position: { x: 4622, y: -499 },
    pointVectors: [
      { x: 5.347349728531323, y: 7.239188551265673 },
      { x: -0.8663715821958213, y: 13.973167152852767 },
      { x: -6.20065147509643, y: 6.523183370439962 },
      { x: -12.917660964645957, y: 1.4608337353929357 },
      { x: -11.66793193459886, y: -7.736883375724886 },
      { x: -2.2657037998195433, y: -7.672456340148393 },
      { x: 3.5956463239158816, y: -8.250534983460781 },
      { x: 11.638996122737923, y: -5.790834935904459 },
      { x: 12.638265249846047, y: 3.0453655732167553 },
    ],
  },
  {
    position: { x: -2033, y: -1568 },
    pointVectors: [
      { x: -1.5654429262981746, y: 8.862809286253597 },
      { x: -8.458139453941332, y: 3.075691300777932 },
      { x: -6.892696527643162, y: -5.787117985475664 },
      { x: 2.4351334409082575, y: -13.786592223061154 },
      { x: 10.337725999261623, y: -3.7591782565063716 },
      { x: 8.424406867119426, y: 7.073144204470247 },
    ],
  },
];
